/* eslint-disable import/no-cycle */
import React from 'react'

import IconNames from './iconNames'

const Icons = {
  [IconNames.Account]: {
    element: (
      <g key="account">
        <path d="M12,19.2C9.5,19.2 7.29,17.92 6,16C6.03,14 10,12.9 12,12.9C14,12.9 17.97,14 18,16C16.71,17.92 14.5,19.2 12,19.2M12,5A3,3 0 0,1 15,8A3,3 0 0,1 12,11A3,3 0 0,1 9,8A3,3 0 0,1 12,5M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z" />
      </g>
    )
  },
  [IconNames.AccountBorderless]: {
    element: (
      <g key="account-borderless">
        <path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z" />
      </g>
    )
  },
  [IconNames.Airport]: {
    element: (
      <g key="airport" transform="translate(-22.000000, -849.000000)">
        <g
          id="airport"
          transform="translate(30.500000, 855.000000) rotate(45.000000) translate(-30.500000, -855.000000) translate(23.000000, 847.000000)"
        >
          <path
            id="Shape"
            d="M15,11.2 L15,9.6 L8.68421053,5.6 L8.68421053,1.2 C8.68421053,0.5372583 8.15402141,0 7.5,0 C6.84597859,0 6.31578947,0.5372583 6.31578947,1.2 L6.31578947,5.6 L0,9.6 L0,11.2 L6.31578947,9.2 L6.31578947,13.6 L4.73684211,14.8 L4.73684211,16 L7.5,15.2 L10.2631579,16 L10.2631579,14.8 L8.68421053,13.6 L8.68421053,9.2 L15,11.2 Z"
          />
        </g>
      </g>
    )
  },
  [IconNames.Aerolineas]: {
    width: 200,
    height: 34,
    element: (
      <g key="aerolineas">
        <defs>
          <path id="a" d="M.448.75H57.84v18.375H.448z" />
        </defs>
        <g fill="none" fillRule="evenodd">
          <path
            fill="#0081C6"
            d="M182.728 5.704c-4.58.774-10.799 1.348-15.485 2.716-.071.021-.058.058.015.056 11.308-.329 23.55-.274 32.693.024.022 0 .051-.04.049-.062-.219-1.054-1.058-2.248-3.593-2.237h-1.466s-.038.025-.033.039c.415 1.008-.744 1.677-1.49 1.066-.316-.257-.629-.894.172-1.445a63.775 63.775 0 0 1 2.064-1.333c1.936-1.194 1.667-2.916-.906-3.106C188.538.962 177.444.342 173.06 0c-.1-.006-.156.063-.088.1 3.627 1.916 6.925 2.089 10.553 3.408 2.062.748 1.656 1.78-.797 2.196M131.517 15.145c-.34-.063-.655-.12-.949-.171a11.4 11.4 0 0 0-.987-.129 29.54 29.54 0 0 0-2.746-.11c-.797 0-1.598.075-2.404.222-.823.152-1.56.427-2.202.826a4.881 4.881 0 0 0-1.589 1.586c-.426.68-.627 1.519-.627 2.497 0 1.528.98 2.883 2.765 4.048l2.865 1.832c.73.444 1.196.83 1.384 1.09.208.285.296.546.298.817-.001.449-.091.803-.25 1.079a1.886 1.886 0 0 1-.663.682 3.313 3.313 0 0 1-1.019.39 5.992 5.992 0 0 1-1.257.133c-.263 0-.598-.012-1.001-.032a64.3 64.3 0 0 1-3.823-.309l-.018-.002h-.21c-.447-.032-.889.307-.946.75l-.195 1.124v.125c-.007.231.089.498.31.644.141.099.304.172.484.221.382.09.784.163 1.22.227.438.065.882.112 1.33.143.442.032.872.057 1.294.078.422.021.804.03 1.148.03h.009c.879 0 1.738-.09 2.576-.27.853-.185 1.614-.489 2.276-.919a4.855 4.855 0 0 0 1.606-1.72c.41-.73.603-1.62.603-2.655.001-.747-.213-1.46-.629-2.11-.43-.673-1.194-1.341-2.291-2.062l-2.834-1.831c-.537-.343-.941-.66-1.208-.94-.244-.258-.345-.508-.348-.811 0-.404.092-.688.244-.891.177-.236.397-.42.677-.564.288-.147.606-.25.96-.306.369-.06.721-.09 1.057-.088.871 0 1.715.025 2.535.077.822.05 1.501.106 2.036.168l.019.002h.116a.94.94 0 0 0 .98-.82l.16-1.057v-.151c.028-.425-.348-.794-.756-.843zM112.672 28.28c-.816.53-1.552.936-2.203 1.22-.671.294-1.34.437-2.022.437-.677-.003-1.217-.205-1.69-.623-.418-.367-.683-1.096-.682-2.25a8.282 8.282 0 0 1 .12-1.364l.566-3.198c.284-1.608.837-2.792 1.627-3.581.775-.775 1.908-1.18 3.48-1.183.658 0 1.214.03 1.663.09.337.045.66.095.968.15l-1.827 10.302zm5.609-12.013a.714.714 0 0 0-.27-.557c-.162-.131-.354-.202-.575-.252a23.142 23.142 0 0 0-2.663-.516 20.966 20.966 0 0 0-2.904-.206c-.973 0-1.915.124-2.825.37a7.269 7.269 0 0 0-2.524 1.24c-.763.58-1.417 1.34-1.959 2.275-.549.944-.946 2.104-1.203 3.477l-.564 3.072c-.129.657-.195 1.3-.195 1.924 0 .984.135 1.848.415 2.59.276.73.651 1.345 1.13 1.83a4.498 4.498 0 0 0 1.686 1.077 5.843 5.843 0 0 0 2.015.347h.007c.539 0 1.03-.038 1.473-.113.442-.077.87-.198 1.28-.362a9.027 9.027 0 0 0 1.21-.599c.193-.112.394-.237.603-.375l-.028.168v.215c0 .193.04.387.153.553.168.24.438.296.674.296h1.255c.258.002.51-.105.697-.279.181-.165.312-.376.371-.607l.004-.015 2.698-15.229c.029-.103.038-.207.039-.324zm-19.948 6.008h-7.581c.139-.594.33-1.138.572-1.634a6 6 0 0 1 1.022-1.496 4.202 4.202 0 0 1 1.375-.972 4.262 4.262 0 0 1 1.737-.342c1.076.002 1.816.26 2.291.72.475.463.739 1.175.742 2.215 0 .454-.053.957-.158 1.509zm2.125-5.75a5.49 5.49 0 0 0-1.91-1.31c-.767-.323-1.663-.479-2.682-.479-2.307-.002-4.24.686-5.72 2.066-1.482 1.377-2.456 3.352-2.946 5.884l-.408 2.172a11.106 11.106 0 0 0-.194 1.987c0 1.096.183 2.038.57 2.823.374.765.873 1.4 1.494 1.89a5.903 5.903 0 0 0 2.103 1.057c.77.214 1.56.323 2.363.323h.008c1.077 0 2.037-.046 2.88-.141a43.384 43.384 0 0 0 2.674-.392c.298-.048.552-.12.752-.328.163-.183.24-.407.29-.67l.194-1.086v-.155a.632.632 0 0 0-.242-.513c-.163-.121-.344-.15-.524-.151h-.212l-.026.004c-.725.103-1.578.2-2.556.292a30.2 30.2 0 0 1-2.822.14c-1.164-.001-2.039-.25-2.657-.707-.586-.436-.903-1.143-.907-2.261-.001-.276.015-.565.045-.864.028-.285.09-.594.19-.928l.032-.119h10.231c.287.003.587-.083.773-.327a1.59 1.59 0 0 0 .268-.638l.251-1.308c.13-.68.195-1.322.195-1.927 0-.839-.121-1.632-.362-2.373a5.24 5.24 0 0 0-1.145-1.96zm-15.867-.27c-.416-.479-.952-.852-1.592-1.119-.652-.27-1.417-.4-2.287-.4-1.1 0-2.064.149-2.888.458-.578.216-1.149.465-1.713.748v-.139a.928.928 0 0 0-.174-.544c-.15-.217-.42-.312-.653-.306h-1.539a1.02 1.02 0 0 0-.696.28 1.22 1.22 0 0 0-.372.609l-.004.014-2.798 15.86v.155a.926.926 0 0 0 .174.545c.142.21.402.305.63.305h1.561a1.08 1.08 0 0 0 .702-.271c.193-.163.337-.375.397-.616l.003-.014 2.292-12.922c.916-.426 1.678-.706 2.272-.844a8.135 8.135 0 0 1 1.832-.223c1.113-.005 1.797.218 2.064.51.319.335.495.809.498 1.495 0 .234-.015.496-.046.786-.03.295-.067.585-.109.87l-1.822 10.225v.154c-.001.22.057.453.23.623.172.17.406.228.628.227h1.507a1.08 1.08 0 0 0 .703-.271c.193-.162.337-.375.396-.616l.003-.01 1.823-10.221a9.732 9.732 0 0 0 .161-1.736 6.67 6.67 0 0 0-.28-1.964 4.524 4.524 0 0 0-.903-1.647zm-14.453-4.213l.004-.013.447-2.523v-.156c0-.22-.059-.452-.23-.622-.172-.169-.407-.228-.63-.227h-1.6c-.26-.003-.508.103-.704.272a1.18 1.18 0 0 0-.394.617l-.004.008-.447 2.527v.155c0 .22.057.453.23.623.173.17.407.228.63.226h1.604c.257 0 .504-.103.698-.27.194-.162.337-.377.396-.617zm-1.632 2.911H67c-.259-.001-.509.104-.703.272a1.181 1.181 0 0 0-.397.617l-.002.01-2.802 15.865v.154c0 .222.06.452.232.623.17.169.401.227.62.227h1.515c.259.001.508-.104.702-.271.193-.162.336-.375.396-.616l.003-.009 2.801-15.867v-.155c0-.22-.059-.452-.23-.622-.172-.17-.406-.229-.63-.228zm-4.443-5.447a.829.829 0 0 0-.207-.59.787.787 0 0 0-.59-.229h-1.631a.995.995 0 0 0-1.043.888l-3.927 22.142v.154c0 .214.045.43.199.606.15.172.378.244.582.244h1.648a.964.964 0 0 0 .69-.29c.169-.164.289-.37.346-.597l.004-.013 3.929-22.16v-.155zM53.498 21.702c-.02.275-.06.57-.121.89l-.408 2.364a7.378 7.378 0 0 1-.611 2.002 5.783 5.783 0 0 1-1.046 1.535 4.486 4.486 0 0 1-1.406.993 4.183 4.183 0 0 1-1.744.357c-1.181 0-1.953-.272-2.383-.727-.446-.468-.699-1.205-.7-2.272 0-.51.06-1.1.184-1.765l.406-2.363c.263-1.542.817-2.732 1.644-3.6.824-.862 1.836-1.282 3.134-1.286 1.178 0 1.944.28 2.376.753.452.491.704 1.242.704 2.307 0 .259-.01.53-.03.812zm3.456.125c.033-.303.05-.605.05-.907 0-.88-.127-1.7-.38-2.453a5.276 5.276 0 0 0-1.177-1.977 5.442 5.442 0 0 0-1.945-1.295c-.775-.31-1.662-.46-2.66-.46-4.812-.031-7.807 2.712-8.668 7.862l-.407 2.359c-.044.302-.082.591-.113.874a7.77 7.77 0 0 0-.049.892c0 .9.13 1.733.395 2.488a5.567 5.567 0 0 0 1.174 1.97 5.263 5.263 0 0 0 1.932 1.297c.773.31 1.651.46 2.63.46 1.267 0 2.403-.18 3.403-.55a7.328 7.328 0 0 0 2.57-1.58 8.057 8.057 0 0 0 1.74-2.482c.443-.961.77-2.045.984-3.248l.408-2.36c.044-.302.08-.596.113-.89zM42.753 17.01l.225-1.334v-.155a.739.739 0 0 0-.279-.603c-.19-.144-.411-.183-.643-.184h-.063c-.762 0-1.535.097-2.314.29-.6.149-1.214.43-1.847.838v-.06c0-.218-.051-.441-.214-.614-.163-.174-.398-.24-.614-.237H35.53c-.26-.002-.51.106-.698.28-.181.164-.313.376-.37.609l-.004.014-2.8 15.86v.156c0 .217.052.441.215.614.162.172.393.235.606.235h1.544c.26.002.509-.103.703-.271.194-.162.336-.375.397-.616l.003-.014 2.266-12.852c.7-.419 1.343-.708 1.923-.871.617-.175 1.363-.266 2.24-.266h.094c.522.034 1.039-.299 1.104-.82zm-14.67 5.263h-7.581a7.62 7.62 0 0 1 .571-1.634 6 6 0 0 1 1.022-1.496 4.184 4.184 0 0 1 1.375-.972c.514-.226 1.09-.342 1.738-.342 1.075.002 1.815.26 2.29.72.475.463.738 1.175.74 2.215 0 .454-.051.957-.156 1.509zm3.269-3.79a5.252 5.252 0 0 0-1.144-1.96 5.499 5.499 0 0 0-1.911-1.31c-.767-.323-1.662-.479-2.682-.479-2.308-.002-4.24.686-5.72 2.066-1.48 1.377-2.455 3.352-2.945 5.884l-.41 2.172a11.027 11.027 0 0 0-.193 1.987c0 1.096.183 2.038.57 2.823a5.4 5.4 0 0 0 1.493 1.89 5.907 5.907 0 0 0 2.104 1.057 8.8 8.8 0 0 0 2.371.324c1.078-.001 2.037-.047 2.881-.142a43.457 43.457 0 0 0 2.673-.392c.298-.048.55-.12.752-.329.162-.182.239-.406.289-.669l.194-1.086v-.155a.63.63 0 0 0-.24-.512c-.164-.122-.346-.15-.525-.152h-.214l-.025.004c-.724.103-1.577.2-2.556.292-.973.092-1.913.14-2.82.14-1.166-.001-2.04-.25-2.657-.707-.589-.436-.904-1.143-.909-2.261 0-.276.015-.565.046-.864.029-.285.09-.594.191-.928l.03-.119h10.233c.286.003.586-.083.771-.327.137-.181.219-.396.268-.637l.253-1.309c.13-.68.194-1.322.194-1.927 0-.839-.12-1.632-.362-2.373zm-21.28 9.795c-.816.53-1.552.936-2.204 1.22-.67.294-1.34.437-2.02.438-.678-.004-1.219-.206-1.69-.624-.42-.367-.684-1.096-.683-2.25a8.246 8.246 0 0 1 .12-1.364l.566-3.198c.284-1.608.836-2.792 1.627-3.581.775-.775 1.907-1.18 3.48-1.183.657 0 1.213.03 1.663.09.337.045.66.095.968.15l-1.827 10.302zm4.765-12.822a23.305 23.305 0 0 0-2.664-.516 20.99 20.99 0 0 0-2.905-.206c-.972 0-1.915.124-2.825.37a7.26 7.26 0 0 0-2.523 1.24c-.764.58-1.417 1.34-1.958 2.275-.55.944-.946 2.104-1.203 3.477l-.565 3.072c-.13.657-.194 1.3-.194 1.924 0 .984.134 1.848.414 2.59.275.73.65 1.345 1.131 1.83A4.495 4.495 0 0 0 3.23 32.59a5.84 5.84 0 0 0 2.015.347h.007a8.84 8.84 0 0 0 1.473-.113c.443-.077.87-.198 1.28-.362a8.976 8.976 0 0 0 1.21-.599c.193-.112.393-.237.602-.375l-.028.168v.215c0 .194.043.388.154.553.168.24.439.296.674.296h1.255c.258.002.51-.105.697-.279.18-.165.313-.375.371-.607l.004-.013 2.698-15.23c.028-.104.038-.208.04-.325a.715.715 0 0 0-.27-.557c-.163-.131-.354-.202-.575-.252z"
          />
          <g transform="translate(132.275 14.875)">
            <mask id="b" fill="#fff" />
            <path
              fill="#0081C6"
              d="M57.564 3.634a3.973 3.973 0 0 0-.863-1.499 4.162 4.162 0 0 0-1.48-1.01C54.622.876 53.912.75 53.087.75c-.912 0-1.769.104-2.572.31-.803.207-1.726.593-2.767 1.157-.304-.435-.748-.787-1.334-1.059A4.506 4.506 0 0 0 44.494.75c-.825 0-1.617.125-2.377.376-.76.25-1.552.624-2.376 1.123l.098-.619V1.5c0-.347-.163-.521-.49-.521h-1.561a.679.679 0 0 0-.473.195.914.914 0 0 0-.276.456l-2.897 16.615v.164c0 .325.14.488.422.488h1.726a.624.624 0 0 0 .455-.196.965.965 0 0 0 .261-.456l2.409-13.747c.216-.11.494-.234.83-.376.336-.14.7-.276 1.091-.407.391-.13.792-.239 1.204-.325.412-.087.814-.13 1.205-.13.564 0 1.03.123 1.4.374.369.25.554.722.554 1.417 0 .26-.023.528-.065.798-.045.272-.099.593-.164.96l-1.985 11.436v.13c0 .131.026.251.081.359.053.109.168.163.342.163h1.726a.624.624 0 0 0 .455-.196.972.972 0 0 0 .26-.456L48.335 6.81c.044-.194.076-.455.097-.78.022-.327.033-.64.033-.946v-.488c0-.152-.021-.282-.065-.39a8.219 8.219 0 0 1 2.176-.751c.708-.13 1.314-.194 1.815-.194.873 0 1.522.157 1.948.472.424.315.637.907.637 1.775 0 .195-.011.408-.033.636-.022.227-.054.472-.097.733l-1.986 11.37v.13c0 .347.174.521.521.521h1.562a.722.722 0 0 0 .482-.196.885.885 0 0 0 .291-.456l1.962-11.37c.044-.26.082-.5.114-.717.033-.216.048-.444.048-.684 0-.65-.092-1.264-.276-1.84M31.178 7.722a8.46 8.46 0 0 1-.13.978l-.42 2.476a8.194 8.194 0 0 1-.666 2.2 6.472 6.472 0 0 1-1.152 1.71 5.032 5.032 0 0 1-1.573 1.123 4.662 4.662 0 0 1-1.962.407c-1.277 0-2.19-.293-2.742-.879-.552-.586-.827-1.466-.827-2.64 0-.564.064-1.205.195-1.921l.422-2.476c.28-1.672.88-2.998 1.8-3.974.92-.978 2.092-1.466 3.52-1.466 1.276 0 2.19.303 2.74.911.553.61.828 1.5.828 2.671 0 .283-.011.577-.033.88m1.385-5.245a5.276 5.276 0 0 0-1.889-1.27C29.926.903 29.052.75 28.054.75c-4.84 0-7.715 2.65-8.626 7.95l-.424 2.476c-.044.303-.081.602-.114.896a7.978 7.978 0 0 0-.049.896c0 .912.13 1.743.391 2.492.26.75.64 1.395 1.14 1.938.498.543 1.123.966 1.87 1.27.75.305 1.612.457 2.589.457 1.28 0 2.414-.185 3.402-.555a7.227 7.227 0 0 0 2.539-1.58c.705-.683 1.28-1.513 1.726-2.491.443-.978.775-2.085.992-3.323l.423-2.476c.044-.304.082-.608.114-.913.033-.303.049-.607.049-.911 0-.89-.126-1.71-.374-2.46a5.188 5.188 0 0 0-1.14-1.94M19.363 3l.196-1.173c0-.044.004-.082.016-.114a.376.376 0 0 0 .016-.114c0-.26-.185-.424-.553-.489a16.61 16.61 0 0 0-1.824-.261 23.64 23.64 0 0 0-2.18-.098c-2.236 0-4.079.658-5.527 1.971C8.055 4.035 7.11 6.018 6.673 8.668l-.428 2.541c-.044.303-.083.602-.116.895-.033.293-.05.592-.05.896 0 .868.122 1.678.363 2.427a5.47 5.47 0 0 0 1.07 1.939A4.95 4.95 0 0 0 9.3 18.652c.72.315 1.556.473 2.51.473.76 0 1.503-.033 2.231-.098a17.826 17.826 0 0 0 1.904-.26c.26-.044.445-.115.553-.212.108-.098.185-.266.228-.505l.196-1.173v-.097a.33.33 0 0 0-.146-.293.599.599 0 0 0-.344-.1h-.097c-.716.088-1.378.148-1.986.18-.607.033-1.313.05-2.116.05-1.063 0-1.877-.267-2.442-.799-.563-.531-.846-1.417-.846-2.656 0-.564.066-1.215.196-1.953l.424-2.54c.28-1.696.867-3.021 1.757-3.976.89-.957 1.986-1.433 3.288-1.433.804 0 1.492.015 2.067.048.575.033 1.21.093 1.905.179h.098a.822.822 0 0 0 .423-.114c.13-.076.217-.2.26-.374M3.248 14.563H1.686c-.413 0-.652.208-.716.62l-.522 3.03v.13c0 .348.163.521.489.521h1.562a.677.677 0 0 0 .472-.195.918.918 0 0 0 .277-.456l.52-3.03v-.098c0-.347-.173-.522-.52-.522"
              mask="url(#b)"
            />
          </g>
        </g>
      </g>
    )
  },
  [IconNames.AerolineasPlus]: {
    element: (
      <g key="aerolineas-plus">
        <path d="M21.41,11.58L12.41,2.58C12.04,2.21 11.53,2 11,2H4A2,2 0 0,0 2,4V11C2,11.53 2.21,12.04 2.59,12.41L3,12.81C3.9,12.27 4.94,12 6,12A6,6 0 0,1 12,18C12,19.06 11.72,20.09 11.18,21L11.58,21.4C11.95,21.78 12.47,22 13,22C13.53,22 14.04,21.79 14.41,21.41L21.41,14.41C21.79,14.04 22,13.53 22,13C22,12.47 21.79,11.96 21.41,11.58M5.5,7A1.5,1.5 0 0,1 4,5.5A1.5,1.5 0 0,1 5.5,4A1.5,1.5 0 0,1 7,5.5A1.5,1.5 0 0,1 5.5,7M10,19H7V22H5V19H2V17H5V14H7V17H10V19Z" />
      </g>
    )
  },
  [IconNames.Airplane]: {
    element: (
      <g key="airplane">
        <path d="M21,16V14L13,9V3.5A1.5,1.5 0 0,0 11.5,2A1.5,1.5 0 0,0 10,3.5V9L2,14V16L10,13.5V19L8,20.5V22L11.5,21L15,22V20.5L13,19V13.5L21,16Z" />
      </g>
    )
  },
  [IconNames.AirplaneRight]: {
    element: (
      <g key="airplane-right">
        <path d="M10.2,9" />
        <path d="M8.5,21.5h2l5-8H21c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5h-5.5l-5-8h-2l2.5,8H5.5L4,8.5H2.5l1,3.5l-1,3.5H4l1.5-2H11 L8.5,21.5z" />
        <path style={{ fill: 'none' }} d="M0,0h24v24H0V0z" />
      </g>
    )
  },
  [IconNames.AirplaneLandingLeft]: {
    element: (
      <g key="airplane-landing-left">
        <path d="M16.025 2l-2.168 8.004h5.166l1.5-2h1.498l-1.332 5.002H3.527a1.493 1.493 0 0 1-1.498-1.5c0-.835.666-1.502 1.5-1.502h5.498L14.025 2zM6.004 14l.941.94-2.463 2.466H20.69v1.25H4.547l2.398 2.397-.941.947-4-4z" />
      </g>
    )
  },
  [IconNames.AirplaneLandingRight]: {
    element: (
      <g key="airplane-landing-right">
        <path d="M8 2l2.168 8.004H5.002l-1.5-2H2.004l1.332 5.002h17.162c.833 0 1.498-.667 1.498-1.5 0-.835-.666-1.502-1.5-1.502h-5.498L10 2H8zm10.021 12l-.94.94 2.462 2.466H3.336v1.25h16.143l-2.399 2.397.941.947 4-4-4-4z" />
      </g>
    )
  },
  [IconNames.Alert]: {
    element: (
      <g key="alert">
        <path d="M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z" />
      </g>
    )
  },
  [IconNames.AutoRenew]: {
    element: (
      <g key="autorenew">
        <path d="M12,6V9L16,5L12,1V4A8,8 0 0,0 4,12C4,13.57 4.46,15.03 5.24,16.26L6.7,14.8C6.25,13.97 6,13 6,12A6,6 0 0,1 12,6M18.76,7.74L17.3,9.2C17.74,10.04 18,11 18,12A6,6 0 0,1 12,18V15L8,19L12,23V20A8,8 0 0,0 20,12C20,10.43 19.54,8.97 18.76,7.74Z" />
      </g>
    )
  },
  [IconNames.ArrowDown]: {
    element: (
      <g key="arrow-down">
        <path d="M2.8,0L12,9.3L21.2,0L24,2.9L12,15L0,2.9L2.8,0z" />
      </g>
    )
  },
  [IconNames.ArrowLeft]: {
    element: (
      <g key="arrow-left">
        <path d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z" />
      </g>
    )
  },
  [IconNames.ArrowRight]: {
    element: (
      <g key="arrow-right">
        <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
      </g>
    )
  },
  [IconNames.Basket]: {
    element: (
      <g key="basket">
        <path d="M11.7859417,10.4970485 L19.2485825,10.4970485 L19.2485825,10.5880388 C19.2485825,13.5584466 16.8319612,15.975068 13.8615534,15.975068 L6.02198058,15.975068 C3.05157282,15.975068 0.634951456,13.5584466 0.634951456,10.5880388 L0.634951456,10.4970485 L8.09747573,10.4970485 C7.93382524,10.7959612 7.84058252,11.1386796 7.84058252,11.502835 C7.84058252,12.6613981 8.78314563,13.6039612 9.94170874,13.6039612 C11.1002718,13.6039612 12.042835,12.6613981 12.042835,11.502835 C12.042835,11.1387184 11.9496311,10.7959612 11.7859417,10.4970485 Z M19.3009709,8.17537864 C19.6226796,8.17537864 19.8834951,8.43619417 19.8834951,8.75786408 C19.8834951,9.0472233 19.6722718,9.28664078 19.3957282,9.332 L11.6592621,9.332 L11.6592621,10.2947961 C11.2785631,9.75518447 10.6508738,9.40170874 9.94174757,9.40170874 C9.23262136,9.40170874 8.6048932,9.75518447 8.22423301,10.2947961 L8.22423301,9.332 L0.48776699,9.332 C0.211223301,9.28664078 0,9.0472233 0,8.75786408 C0,8.43615534 0.260815534,8.17533981 0.582524272,8.17533981 L8.22431068,8.17533981 L8.22431068,1.7376699 C8.22431068,0.793242718 8.99266019,0.0248932039 9.93708738,0.0248932039 L9.94648544,0.0248932039 C10.8909126,0.0248932039 11.6592621,0.793242718 11.6592621,1.7376699 L11.6592621,8.17537864 L19.3009709,8.17537864 Z M9.94174757,10.5667573 C10.4579029,10.5667573 10.8778252,10.9867184 10.8778252,11.502835 C10.8778252,12.0189903 10.4579029,12.4389126 9.94174757,12.4389126 C9.42559223,12.4389126 9.0056699,12.0189903 9.0056699,11.502835 C9.0056699,10.9866796 9.42559223,10.5667573 9.94174757,10.5667573 Z" />
      </g>
    )
  },
  [IconNames.Bell]: {
    element: (
      <g key="bell">
        <path d="M12,22A2,2 0 0,0 14,20H10A2,2 0 0,0 12,22M18,16V11C18,7.93 16.36,5.36 13.5,4.68V4A1.5,1.5 0 0,0 12,2.5A1.5,1.5 0 0,0 10.5,4V4.68C7.63,5.36 6,7.92 6,11V16L4,18V19H20V18L18,16Z" />
      </g>
    )
  },
  [IconNames.BellOff]: {
    element: (
      <g key="bell-off">
        <path d="M20,18.69L7.84,6.14L5.27,3.5L4,4.76L6.8,7.56V7.57C6.28,8.56 6,9.73 6,11V16L4,18V19H17.73L19.73,21L21,19.72L20,18.69M12,22C13.11,22 14,21.11 14,20H10C10,21.11 10.89,22 12,22M18,14.68V11C18,7.92 16.36,5.36 13.5,4.68V4A1.5,1.5 0 0,0 12,2.5A1.5,1.5 0 0,0 10.5,4V4.68C10.35,4.71 10.21,4.76 10.08,4.8C10,4.83 9.88,4.87 9.78,4.91L9.75,4.92C9.5,5 9.29,5.12 9.06,5.24L18,14.68Z" />
      </g>
    )
  },
  [IconNames.Briefcase]: {
    element: (
      <g key="briefcase">
        <path d="M10,2H14A2,2 0 0,1 16,4V6H20A2,2 0 0,1 22,8V19A2,2 0 0,1 20,21H4C2.89,21 2,20.1 2,19V8C2,6.89 2.89,6 4,6H8V4C8,2.89 8.89,2 10,2M14,6V4H10V6H14Z" />
      </g>
    )
  },
  [IconNames.Briefcases]: {
    element: (
      <g key="briefcases">
        <path d="M6,22.2c0.7,0,1.2-0.5,1.2-1.2H4.8C4.8,21.7,5.3,22.2,6,22.2z" />
        <path d="M3.4,6.9v13.2c0,0.2,0.2,0.4,0.4,0.4h1.8v-14H3.8C3.6,6.5,3.4,6.7,3.4,6.9z" />
        <path d="M11.9,13.4c0-0.2,0.1-0.5,0.3-0.7V6.5H6.4V4.1h5.8v2.4h0.7V12c0.3-0.1,0.5-0.2,0.8-0.2h1.5v-5c0-0.2-0.2-0.4-0.4-0.4H13V2c0-0.2-0.2-0.4-0.4-0.4H6C5.8,1.6,5.6,1.8,5.6,2v4.5h0.7v14h1.6v-5.1c0-1.1,0.9-2,2-2H11.9z M6.4,2.4h5.8v0.9H6.4V2.4z M7.7,9.5c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.3,0.4-0.3H11c0.2,0,0.4,0.2,0.4,0.4s-0.3,0.3-0.5,0.3H7.7z" />
        <path d="M16.3,13.8c0-0.7-0.5-1.2-1.2-1.2H14c-0.2,0-0.4,0.1-0.6,0.1c-0.4,0.2-0.6,0.6-0.6,1V14h-1.2v8.4h5.8V14h-1.1V13.8z M15.4,14h-1.7c0-0.1,0-0.2,0-0.2c0-0.1,0.1-0.3,0.3-0.3h1.1c0.1,0,0.3,0.1,0.3,0.3V14z" />
        <path d="M19,14h-0.9v8.4H19c0.9,0,1.5-0.8,1.6-1.8v-4.8C20.6,14.7,19.9,14,19,14z" />
        <path d="M8.6,15.8v4.8c0,1,0.8,1.8,1.8,1.8h0.5V14h-0.5C9.4,14,8.6,14.8,8.6,15.8z" />
      </g>
    )
  },
  [IconNames.BriefcaseCheck]: {
    element: (
      <g key="briefcase-check">
        <path d="M10,2H14A2,2 0 0,1 16,4V6H20A2,2 0 0,1 22,8V19A2,2 0 0,1 20,21H4A2,2 0 0,1 2,19V8A2,2 0 0,1 4,6H8V4A2,2 0 0,1 10,2M14,6V4H10V6H14M10.5,17.5L17.09,10.91L15.68,9.5L10.5,14.67L8.41,12.59L7,14L10.5,17.5Z" />
      </g>
    )
  },
  [IconNames.Business]: {
    element: (
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Corporativo-|-Solicitud-de-acuerdo" transform="translate(-71.000000, -954.000000)">
          <g id="Group-31">
            <g id="Group-20">
              <g id="Group-18" transform="translate(69.000000, 951.000000)">
                <g id="business-24px">
                  <polygon id="Path" points="0 0 24 0 24 24 0 24" />
                  <path
                    d="M12,7 L12,3 L2,3 L2,21 L22,21 L22,7 L12,7 Z M6,19 L4,19 L4,17 L6,17 L6,19 Z M6,15 L4,15 L4,13 L6,13 L6,15 Z M6,11 L4,11 L4,9 L6,9 L6,11 Z M6,7 L4,7 L4,5 L6,5 L6,7 Z M10,19 L8,19 L8,17 L10,17 L10,19 Z M10,15 L8,15 L8,13 L10,13 L10,15 Z M10,11 L8,11 L8,9 L10,9 L10,11 Z M10,7 L8,7 L8,5 L10,5 L10,7 Z M20,19 L12,19 L12,17 L14,17 L14,15 L12,15 L12,13 L14,13 L14,11 L12,11 L12,9 L20,9 L20,19 Z M18,11 L16,11 L16,13 L18,13 L18,11 Z M18,15 L16,15 L16,17 L18,17 L18,15 Z"
                    id="Shape"
                    fill="#396FA5"
                    fillRule="nonzero"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    )
  },
  [IconNames.AddCircleOutline]: {
    width: 20,
    height: 20,
    element: (
      <g key="add-circle-outline">
        <path d="M11 5H9v4H5v2h4v4h2v-4h4V9h-4V5zm-1-5C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
      </g>
    )
  },
  [IconNames.RemoveCircleOutline]: {
    width: 20,
    height: 20,
    element: (
      <g key="remove-circle-outline">
        <path d="M14.2426407 7.17157288l-1.4142136-1.41421357L10 8.5857864 7.17157288 5.75735931 5.75735931 7.17157288 8.5857864 10l-2.82842709 2.8284271 1.41421357 1.4142136L10 11.4142136l2.8284271 2.8284271 1.4142136-1.4142136L11.4142136 10l2.8284271-2.82842712zM10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
      </g>
    )
  },
  [IconNames.NotebookCheck]: {
    element: (
      <g key="notebook-check">
        <path d="M0.33,19.14h23.34c0.12,0,0.21-0.1,0.21-0.21v-0.47c0-0.06-0.02-0.11-0.06-0.15l-2.51-2.55c-0.04-0.04-0.1-0.06-0.15-0.06H2.88c-0.06,0-0.11,0.02-0.15,0.06l-2.56,2.55c-0.04,0.04-0.06,0.1-0.06,0.16l0.01,0.47C0.12,19.05,0.21,19.14,0.33,19.14z" />
        <path d="M20.77,15.69H3.26c-0.26,0-0.47-0.21-0.47-0.47V4.49c0-0.26,0.21-0.47,0.47-0.47h17.51c0.26,0,0.47,0.21,0.47,0.47v10.73C21.24,15.48,21.03,15.69,20.77,15.69z" />
        <polygon
          style={{
            fill: 'none',
            stroke: '#FFFFFF',
            strokeWidth: '0.3315',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeMiterlimit: '10'
          }}
          points="15.41,18.09 8.56,18.09 9.31,16.75 14.66,16.75"
        />
        <polyline
          style={{
            fill: 'none',
            stroke: '#FFFFFF',
            strokeWidth: '0.3315',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeMiterlimit: '10'
          }}
          points="4.57,13.9 4.57,5.71 19.37,5.71 19.37,13.9"
        />
        <polyline
          style={{
            fill: 'none',
            stroke: '#FFFFFF',
            strokeWidth: '0.611',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeMiterlimit: '10'
          }}
          points="10.3,11.11 11.11,12.14 14.54,8.37"
        />
        <line
          style={{
            fill: 'none',
            stroke: '#FFFFFF',
            strokeWidth: '0.3315',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeMiterlimit: '10'
          }}
          x1="3.33"
          y1="15.69"
          x2="20.47"
          y2="15.69"
        />
      </g>
    )
  },
  [IconNames.CalendarClock]: {
    element: (
      <g key="calendar-clock">
        <path d="M15,13H16.5V15.82L18.94,17.23L18.19,18.53L15,16.69V13M19,8H5V19H9.67C9.24,18.09 9,17.07 9,16A7,7 0 0,1 16,9C17.07,9 18.09,9.24 19,9.67V8M5,21C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H6V1H8V3H16V1H18V3H19A2,2 0 0,1 21,5V11.1C22.24,12.36 23,14.09 23,16A7,7 0 0,1 16,23C14.09,23 12.36,22.24 11.1,21H5M16,11.15A4.85,4.85 0 0,0 11.15,16C11.15,18.68 13.32,20.85 16,20.85A4.85,4.85 0 0,0 20.85,16C20.85,13.32 18.68,11.15 16,11.15Z" />
      </g>
    )
  },
  [IconNames.Calendar]: {
    element: (
      <g key="calendar">
        <path d="M19,19H5V8H19M16,1V3H8V1H6V3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3H18V1" />
      </g>
    )
  },
  [IconNames.Cellphone]: {
    element: (
      <g key="Cellphone">
        <path d="M16,18H7V4H16M11.5,22A1.5,1.5 0 0,1 10,20.5A1.5,1.5 0 0,1 11.5,19A1.5,1.5 0 0,1 13,20.5A1.5,1.5 0 0,1 11.5,22M15.5,1H7.5A2.5,2.5 0 0,0 5,3.5V20.5A2.5,2.5 0 0,0 7.5,23H15.5A2.5,2.5 0 0,0 18,20.5V3.5A2.5,2.5 0 0,0 15.5,1Z" />
      </g>
    )
  },
  [IconNames.Change]: {
    element: (
      <g key="change">
        <path d="M12,6V9L16,5L12,1V4A8,8 0 0,0 4,12C4,13.57 4.46,15.03 5.24,16.26L6.7,14.8C6.25,13.97 6,13 6,12A6,6 0 0,1 12,6M18.76,7.74L17.3,9.2C17.74,10.04 18,11 18,12A6,6 0 0,1 12,18V15L8,19L12,23V20A8,8 0 0,0 20,12C20,10.43 19.54,8.97 18.76,7.74Z" />
      </g>
    )
  },
  [IconNames.ChatLeft]: {
    element: (
      <g key="ChatLeft">
        <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2M20 16H5.2L4 17.2V4H20V16Z" />
      </g>
    )
  },
  [IconNames.Check]: {
    element: (
      <g key="check">
        <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
      </g>
    )
  },
  [IconNames.Checkmark]: {
    element: (
      <g key="checkmark">
        <path d="M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2,4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z" />
      </g>
    )
  },
  [IconNames.ChevronDown]: {
    element: (
      <g key="chevron-down">
        <path d="M7.41,8.59L12,13.17l4.59-4.58L18,10l-6,6l-6-6L7.41,8.59z" />
      </g>
    )
  },
  [IconNames.ChevronLeft]: {
    element: (
      <g key="chevron-left">
        <path d="M15.41,16.59L10.83,12l4.58-4.59L14,6l-6,6l6,6L15.41,16.59z" />
      </g>
    )
  },
  [IconNames.ChevronRight]: {
    element: (
      <g key="chevron-right">
        <path d="M8.59,16.59L13.17,12L8.59,7.41L10,6l6,6l-6,6L8.59,16.59z" />
      </g>
    )
  },
  [IconNames.ChevronUp]: {
    element: (
      <g key="chevron-up">
        <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" />
      </g>
    )
  },
  [IconNames.ClipboardText]: {
    element: (
      <g key="clipboard-text">
        <path d="M17,9H7V7H17M17,13H7V11H17M14,17H7V15H14M12,3A1,1 0 0,1 13,4A1,1 0 0,1 12,5A1,1 0 0,1 11,4A1,1 0 0,1 12,3M19,3H14.82C14.4,1.84 13.3,1 12,1C10.7,1 9.6,1.84 9.18,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3Z" />
      </g>
    )
  },
  [IconNames.DialogBalloonInfo]: {
    element: (
      <g key="dialogballoon-info">
        <path d="M22.36,11.54c0,4.37-4.59,7.92-10.25,7.92c-2.1,0-4.06-0.49-5.69-1.33c0,0-3.57,1.39-3.26,1.22c0.9-0.52,1.06-2.75,0.85-2.95c-1.35-1.34-2.15-3.03-2.15-4.86c0-4.37,4.59-7.92,10.25-7.92S22.36,7.16,22.36,11.54z" />
        <path
          style={{ fill: '#FFFFFF' }}
          d="M11.56,7.15h1.16c0.11,0,0.2,0.09,0.2,0.2v1.18c0,0.11-0.09,0.2-0.2,0.2h-1.16c-0.11,0-0.2-0.09-0.2-0.2V7.36C11.36,7.24,11.45,7.15,11.56,7.15z M11.56,9.49h1.16c0.11,0,0.2,0.09,0.2,0.2v5.46c0,0.11-0.09,0.2-0.2,0.2h-1.16c-0.11,0-0.2-0.09-0.2-0.2V9.69C11.36,9.58,11.45,9.49,11.56,9.49z"
        />
      </g>
    )
  },
  [IconNames.ClockAlert]: {
    element: (
      <g key="clock-alert">
        <path d="M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22C14.25,22 16.33,21.24 18,20V17.28C16.53,18.94 14.39,20 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C15.36,4 18.23,6.07 19.41,9H21.54C20.27,4.94 16.5,2 12,2M11,7V13L16.25,16.15L17,14.92L12.5,12.25V7H11M20,11V18H22V11H20M20,20V22H22V20H20Z" />
      </g>
    )
  },
  [IconNames.ClockFast]: {
    width: 33,
    height: 26,
    element: (
      <g key="clock-fast">
        <path d="M20.0307683,0 C26.3523043,0 31.4769217,5.12484725 31.4769217,11.4466667 C31.4769217,17.7684862 26.3523043,22.8933334 20.0307683,22.8933334 C13.7092324,22.8933334 8.584615,17.7684862 8.584615,11.4466667 C8.584615,5.12484725 13.7092324,1.27083529e-15 20.0307683,0 Z M20.0307683,2.86166668 C15.2896164,2.86166668 11.4461533,6.70530212 11.4461533,11.4466667 C11.4461533,16.1880313 15.2896164,20.0316668 20.0307683,20.0316668 C24.7719203,20.0316668 28.6153833,16.1880313 28.6153833,11.4466667 C28.6153833,6.70530212 24.7719203,2.86166668 20.0307683,2.86166668 Z M18.5999992,5.72333336 L20.7461529,5.72333336 L20.7461529,11.1318834 L24.0798451,14.4657251 L22.5632298,15.9824084 L18.5999992,12.0190001 L18.5999992,5.72333336 Z M1.43076917,20.0316668 C0.640577175,20.0316668 0,19.3910608 0,18.6008334 C-1.58847287e-16,17.810606 0.640577175,17.1700001 1.43076917,17.1700001 L6.91061508,17.1700001 C7.35415352,18.1858917 7.92646118,19.1445501 8.584615,20.0316668 L1.43076917,20.0316668 Z M2.86153833,12.8775001 C2.07134634,12.8775001 1.43076917,12.2368942 1.43076917,11.4466667 C1.43076917,10.6564393 2.07134634,10.0158334 2.86153833,10.0158334 L5.79461513,10.0158334 L5.72307667,11.4466667 L5.79461513,12.8775001 L2.86153833,12.8775001 Z M4.2923075,5.72333336 C3.50211551,5.72333336 2.86153833,5.08272745 2.86153833,4.29250002 C2.86153833,3.50227259 3.50211551,2.86166668 4.2923075,2.86166668 L8.584615,2.86166668 C7.92646118,3.74878335 7.35415352,4.70744169 6.91061508,5.72333336 L4.2923075,5.72333336 Z" />
      </g>
    )
  },
  [IconNames.Clock]: {
    element: (
      <g key="clock">
        <path d="M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C6.47,22 2,17.5 2,12A10,10 0 0,1 12,2M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z" />
      </g>
    )
  },
  [IconNames.Close]: {
    element: (
      <g key="close">
        <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
      </g>
    )
  },
  [IconNames.CloseCircle]: {
    element: (
      <g key="close-circle">
        <path d="M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z" />
      </g>
    )
  },
  [IconNames.Collection]: {
    element: (
      <g key="collection">
        <path
          d="M0.0078125,4.39748386 L2.17682658,4.39748386 L2.17682658,19.8387984 L17.6181411,19.8387984 L17.6181411,22.0078125 L2.17682658,22.0078125 C1.59153414,22.0078125 1.0837145,21.7926347 0.653352406,21.3622726 C0.222990317,20.9319105 0.0078125,20.4240909 0.0078125,19.8387984 L0.0078125,4.39748386 Z M9.92330546,11.0078125 L6.61814114,15.3974839 L19.8387984,15.3974839 L15.3974839,9.92330546 L12.1439627,14.0031177 L9.92330546,11.0078125 Z M22.0078125,15.3974839 C22.0078125,15.9827763 21.7926347,16.4992031 21.3622726,16.9467796 C20.9319105,17.3943562 20.4240909,17.6181411 19.8387984,17.6181411 L6.61814114,17.6181411 C6.0328487,17.6181411 5.51642194,17.3943562 5.06884536,16.9467796 C4.62126879,16.4992031 4.39748386,15.9827763 4.39748386,15.3974839 L4.39748386,2.17682658 C4.39748386,1.59153414 4.62126879,1.0837145 5.06884536,0.653352406 C5.51642194,0.222990317 6.0328487,0.0078125 6.61814114,0.0078125 L19.8387984,0.0078125 C20.4240909,0.0078125 20.9319105,0.222990317 21.3622726,0.653352406 C21.7926347,1.0837145 22.0078125,1.59153414 22.0078125,2.17682658 L22.0078125,15.3974839 Z"
          id=""
          fill="#000000"
        />
      </g>
    )
  },
  [IconNames.Computer]: {
    element: (
      <g key="computer">
        <path d="M4,6H20V16H4M20,18A2,2 0 0,0 22,16V6C22,4.89 21.1,4 20,4H4C2.89,4 2,4.89 2,6V16A2,2 0 0,0 4,18H0V20H24V18H20Z" />
      </g>
    )
  },
  [IconNames.CreditCard]: {
    element: (
      <g key="credit-card">
        <path d="M20,8H4V6H20M20,18H4V12H20M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z" />
      </g>
    )
  },
  [IconNames.CreditCardOff]: {
    element: (
      <g key="credit-card-off">
        <path d="M0.93,4.2L2.21,2.93L20,20.72L18.73,22L16.73,20H4C2.89,20 2,19.1 2,18V6C2,5.78 2.04,5.57 2.11,5.38L0.93,4.2M20,8V6H7.82L5.82,4H20A2,2 0 0,1 22,6V18C22,18.6 21.74,19.13 21.32,19.5L19.82,18H20V12H13.82L9.82,8H20M4,8H4.73L4,7.27V8M4,12V18H14.73L8.73,12H4Z" />
      </g>
    )
  },
  [IconNames.Currency]: {
    element: (
      <g key="currency">
        <path d="M7,15H9C9,16.08 10.37,17 12,17C13.63,17 15,16.08 15,15C15,13.9 13.96,13.5 11.76,12.97C9.64,12.44 7,11.78 7,9C7,7.21 8.47,5.69 10.5,5.18V3H13.5V5.18C15.53,5.69 17,7.21 17,9H15C15,7.92 13.63,7 12,7C10.37,7 9,7.92 9,9C9,10.1 10.04,10.5 12.24,11.03C14.36,11.56 17,12.22 17,15C17,16.79 15.53,18.31 13.5,18.82V21H10.5V18.82C8.47,18.31 7,16.79 7,15Z" />
      </g>
    )
  },
  [IconNames.CreditCardPlus]: {
    element: (
      <g key="credit-card-plus">
        <path d="M21,18H24V20H21V23H19V20H16V18H19V15H21V18M19,8V6H3V8H19M19,12H3V18H14V20H3C1.89,20 1,19.1 1,18V6C1,4.89 1.89,4 3,4H19A2,2 0 0,1 21,6V13H19V12Z" />
      </g>
    )
  },
  [IconNames.ClockOutline]: {
    element: (
      <g key="clock-outline">
        <path d="M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22C6.47,22 2,17.5 2,12A10,10 0 0,1 12,2M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z" />
      </g>
    )
  },
  [IconNames.Dialog]: {
    element: (
      <g key="dialog">
        <path d="M20,2H4A2,2 0 0,0 2,4V22L6,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2M20,16H6L4,18V4H20" />
      </g>
    )
  },
  [IconNames.DollarSign]: {
    element: (
      <g key="dollar-sign">
        <path d="M7,15H9C9,16.08 10.37,17 12,17C13.63,17 15,16.08 15,15C15,13.9 13.96,13.5 11.76,12.97C9.64,12.44 7,11.78 7,9C7,7.21 8.47,5.69 10.5,5.18V3H13.5V5.18C15.53,5.69 17,7.21 17,9H15C15,7.92 13.63,7 12,7C10.37,7 9,7.92 9,9C9,10.1 10.04,10.5 12.24,11.03C14.36,11.56 17,12.22 17,15C17,16.79 15.53,18.31 13.5,18.82V21H10.5V18.82C8.47,18.31 7,16.79 7,15Z" />
      </g>
    )
  },
  [IconNames.DotsHorizontal]: {
    element: (
      <g key="dots-horizontal">
        <path d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,10.5A1.5,1.5 0 0,0 10.5,12A1.5,1.5 0 0,0 12,13.5A1.5,1.5 0 0,0 13.5,12A1.5,1.5 0 0,0 12,10.5M6.5,10.5A1.5,1.5 0 0,0 5,12A1.5,1.5 0 0,0 6.5,13.5A1.5,1.5 0 0,0 8,12A1.5,1.5 0 0,0 6.5,10.5M17.5,10.5A1.5,1.5 0 0,0 16,12A1.5,1.5 0 0,0 17.5,13.5A1.5,1.5 0 0,0 19,12A1.5,1.5 0 0,0 17.5,10.5Z" />
      </g>
    )
  },
  [IconNames.Download]: {
    element: (
      <g key="download">
        <path d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />
      </g>
    )
  },
  [IconNames.Duration]: {
    element: (
      <g key="duration">
        <g
          id="Búsqueda-Branded-fares---Filtros-descolapsados"
          transform="translate(-23.000000, -1437.000000)"
        >
          <g id="duraciondeviaje" transform="translate(23.000000, 1437.000000)">
            <path
              id="Shape"
              d="M14.3,13h1.6v3.1l2.6,1.5L17.7,19l-3.5-2V13z M18.6,7.6H3.4v11.9h5.1c-0.5-1-0.7-2.1-0.7-3.2
            c0-4.2,3.4-7.6,7.6-7.6c1.2,0,2.3,0.3,3.2,0.7V7.6z M3.4,21.7c-1.2,0-2.2-1-2.2-2.2V4.4c0-1.2,1-2.2,2.2-2.2h1.1V0h2.2v2.2h8.7V0
            h2.2v2.2h1.1c1.2,0,2.2,1,2.2,2.2V11c1.3,1.4,2.2,3.2,2.2,5.3c0,4.2-3.4,7.6-7.6,7.6c-2.1,0-3.9-0.8-5.3-2.2H3.4z M15.3,11
            c-2.9,0-5.2,2.3-5.2,5.2c0,2.9,2.3,5.2,5.2,5.2c1.4,0,2.7-0.6,3.7-1.5c1-1,1.5-2.3,1.5-3.7C20.6,13.4,18.2,11,15.3,11z"
            />
          </g>
        </g>
      </g>
    )
  },
  [IconNames.Email]: {
    element: (
      <g key="email">
        <path d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z" />
      </g>
    )
  },
  [IconNames.EyeSettings]: {
    element: (
      <g key="eye-settings">
        <path d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,4.5C7.14,4.5 2.78,7.5 1,12C3.39,18.08 10.25,21.06 16.33,18.67C19.38,17.47 21.8,15.06 23,12C21.22,7.5 16.86,4.5 12,4.5M7,22H9V24H7V22M11,22H13V24H11V22M15,22H17V24H15V22Z" />
      </g>
    )
  },
  [IconNames.EyeSettingsOutline]: {
    element: (
      <g key="eye-settings-outline">
        <path d="M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M12,4.5C16.86,4.5 21.22,7.5 23,12C20.61,18.08 13.75,21.06 7.67,18.67C4.62,17.47 2.2,15.06 1,12C2.78,7.5 7.14,4.5 12,4.5M3.18,12C5.56,16.87 11.45,18.89 16.32,16.5C18.28,15.54 19.86,13.96 20.82,12C18.44,7.13 12.55,5.11 7.68,7.5C5.72,8.46 4.14,10.04 3.18,12M9,22H7V24H9V22M13,22H11V24H13V22M17,22H15V24H17V22Z" />
      </g>
    )
  },
  [IconNames.Facebook]: {
    element: (
      <g key="facebook">
        <path d="M17,2V2H17V6H15C14.31,6 14,6.81 14,7.5V10H14L17,10V14H14V22H10V14H7V10H10V6A4,4 0 0,1 14,2H17Z" />
      </g>
    )
  },
  [IconNames.Filter]: {
    element: (
      <g key="filter">
        <path
          d="M2,17.6v2.2h6.7v-2.2H2z M2,4.2v2.2h11.1V4.2H2z M13.1,22v-2.2H22v-2.2h-8.9v-2.2h-2.2V22H13.1z M6.4,8.7v2.2
				H2v2.2h4.4v2.2h2.2V8.7H6.4z M22,13.1v-2.2H10.9v2.2H22z M15.3,8.7h2.2V6.4H22V4.2h-4.4V2h-2.2V8.7z"
        />
      </g>
    )
  },
  [IconNames.FlightTakeOff]: {
    element: (
      <g key="flight-take-off">
        <path d="M2.5,19H21.5V21H2.5V19M22.07,9.64C21.86,8.84 21.03,8.36 20.23,8.58L14.92,10L8,3.57L6.09,4.08L10.23,11.25L5.26,12.58L3.29,11.04L1.84,11.43L3.66,14.59L4.43,15.92L6.03,15.5L11.34,14.07L15.69,12.91L21,11.5C21.81,11.26 22.28,10.44 22.07,9.64Z" />
      </g>
    )
  },
  [IconNames.FoodForkDrink]: {
    element: (
      <g key="food-fork-drink">
        <path d="M3,3A1,1 0 0,0 2,4V8L2,9.5C2,11.19 3.03,12.63 4.5,13.22V19.5A1.5,1.5 0 0,0 6,21A1.5,1.5 0 0,0 7.5,19.5V13.22C8.97,12.63 10,11.19 10,9.5V8L10,4A1,1 0 0,0 9,3A1,1 0 0,0 8,4V8A0.5,0.5 0 0,1 7.5,8.5A0.5,0.5 0 0,1 7,8V4A1,1 0 0,0 6,3A1,1 0 0,0 5,4V8A0.5,0.5 0 0,1 4.5,8.5A0.5,0.5 0 0,1 4,8V4A1,1 0 0,0 3,3M19.88,3C19.75,3 19.62,3.09 19.5,3.16L16,5.25V9H12V11H13L14,21H20L21,11H22V9H18V6.34L20.5,4.84C21,4.56 21.13,4 20.84,3.5C20.63,3.14 20.26,2.95 19.88,3Z" />
      </g>
    )
  },
  [IconNames.FullCircleCheck]: {
    width: 40,
    height: 40,
    element: (
      <g key="full-circle-check">
        <circle cx="20" cy="20" r="19.9" />
        <polygon
          fill="#FFFFFF"
          points="30,14.8 28,12.8 16.6,24.2 12.2,19.7 10.2,21.7 16.6,28.1 16.7,28 16.7,28.1 	"
        />
      </g>
    )
  },
  [IconNames.FullCircleClose]: {
    width: 40,
    height: 40,
    element: (
      <g key="full-circle-check">
        <circle cx="20" cy="20" r="19.9" />
        <polygon
          fill="#FFFFFF"
          points="27.9,26.1 26,28 20,22 14,28 12,26.1 18,20.1 12,14.1 13.9,12.2 19.9,18.2 25.9,12.2
		27.8,14.1 21.8,20.1 	"
        />
      </g>
    )
  },
  [IconNames.Gift]: {
    element: (
      <g key="gift">
        <path d="M20 6h-2.18c.11-.31.18-.65.18-1a2.996 2.996 0 0 0-5.5-1.65l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z" />
      </g>
    )
  },
  [IconNames.Google]: {
    element: (
      <g key="google">
        <path d="M21.35,11.1H12.18V13.83H18.69C18.36,17.64 15.19,19.27 12.19,19.27C8.36,19.27 5,16.25 5,12C5,7.9 8.2,4.73 12.2,4.73C15.29,4.73 17.1,6.7 17.1,6.7L19,4.72C19,4.72 16.56,2 12.1,2C6.42,2 2.03,6.8 2.03,12C2.03,17.05 6.16,22 12.25,22C17.6,22 21.5,18.33 21.5,12.91C21.5,11.76 21.35,11.1 21.35,11.1V11.1Z" />
      </g>
    )
  },
  [IconNames.Headset]: {
    element: (
      <g key="headset">
        <path d="M12,1C7,1 3,5 3,10V17A3,3 0 0,0 6,20H9V12H5V10A7,7 0 0,1 12,3A7,7 0 0,1 19,10V12H15V20H19V21H12V23H18A3,3 0 0,0 21,20V10C21,5 16.97,1 12,1Z" />
      </g>
    )
  },
  [IconNames.HelpCircle]: {
    element: (
      <g key="help-circle">
        <path d="M11,18H13V16H11V18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,6A4,4 0 0,0 8,10H10A2,2 0 0,1 12,8A2,2 0 0,1 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10A4,4 0 0,0 12,6Z" />
      </g>
    )
  },
  [IconNames.Help]: {
    element: (
      <g key="help">
        <path d="M15.07,11.25L14.17,12.17C13.45,12.89 13,13.5 13,15H11V14.5C11,13.39 11.45,12.39 12.17,11.67L13.41,10.41C13.78,10.05 14,9.55 14,9C14,7.89 13.1,7 12,7A2,2 0 0,0 10,9H8A4,4 0 0,1 12,5A4,4 0 0,1 16,9C16,9.88 15.64,10.67 15.07,11.25M13,19H11V17H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12C22,6.47 17.5,2 12,2Z" />
      </g>
    )
  },
  [IconNames.HumanMale]: {
    element: (
      <g key="human-male">
        <path d="M12,2A2,2 0 0,1 14,4A2,2 0 0,1 12,6A2,2 0 0,1 10,4A2,2 0 0,1 12,2M10.5,7H13.5A2,2 0 0,1 15.5,9V14.5H14V22H10V14.5H8.5V9A2,2 0 0,1 10.5,7Z" />
      </g>
    )
  },
  [IconNames.HumanMaleFemale]: {
    element: (
      <g key="human-male-female">
        <path d="M7.5,2A2,2 0 0,1 9.5,4A2,2 0 0,1 7.5,6A2,2 0 0,1 5.5,4A2,2 0 0,1 7.5,2M6,7H9A2,2 0 0,1 11,9V14.5H9.5V22H5.5V14.5H4V9A2,2 0 0,1 6,7M16.5,2A2,2 0 0,1 18.5,4A2,2 0 0,1 16.5,6A2,2 0 0,1 14.5,4A2,2 0 0,1 16.5,2M15,22V16H12L14.59,8.41C14.84,7.59 15.6,7 16.5,7C17.4,7 18.16,7.59 18.41,8.41L21,16H18V22H15Z" />
      </g>
    )
  },
  [IconNames.Ida]: {
    element: (
      <g key="ida">
        <g transform="translate(0 .148)">
          <path
            d="M7.645 10.581l4.051-.004 4.948-.003a1.354 1.354 0 0 0 1.352-1.34 1.357 1.357 0 0 0-1.35-1.341l-4.947.002L7.196.745 5.402.76 7.33 7.9l-4.63.003-1.35-1.786-1.35-.002 1.203 4.459h1.492l4.949.007z"
            mask="url(#b)"
          />
        </g>
        <path d="M17.89 15.278l-2.805-2.779a.363.363 0 0 0-.514 0 .357.357 0 0 0 0 .51l2.184 2.166H4.33c-.005 0-.01.003-.014.003H1.524v.72H16.755l-2.184 2.161a.358.358 0 0 0 0 .51.367.367 0 0 0 .517 0l2.804-2.782a.36.36 0 0 0-.003-.51" />
        <path d="M17.89 15.278l-2.805-2.779a.363.363 0 0 0-.514 0 .357.357 0 0 0 0 .51l2.184 2.166H4.33c-.005 0-.01.003-.014.003H1.524v.72H16.755l-2.184 2.161a.358.358 0 0 0 0 .51.367.367 0 0 0 .517 0l2.804-2.782a.36.36 0 0 0-.003-.51z" />
      </g>
    )
  },
  [IconNames.Info]: {
    element: (
      <g key="info">
        <path d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z" />
      </g>
    )
  },
  [IconNames.Instagram]: {
    element: (
      <g key="instagram">
        <path d="M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2A5.8,5.8 0 0,1 16.2,22H7.8C4.6,22 2,19.4 2,16.2V7.8A5.8,5.8 0 0,1 7.8,2M7.6,4A3.6,3.6 0 0,0 4,7.6V16.4C4,18.39 5.61,20 7.6,20H16.4A3.6,3.6 0 0,0 20,16.4V7.6C20,5.61 18.39,4 16.4,4H7.6M17.25,5.5A1.25,1.25 0 0,1 18.5,6.75A1.25,1.25 0 0,1 17.25,8A1.25,1.25 0 0,1 16,6.75A1.25,1.25 0 0,1 17.25,5.5M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z" />
      </g>
    )
  },
  [IconNames.Language]: {
    element: (
      <g key="language">
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z" />
      </g>
    )
  },
  [IconNames.Linkedin]: {
    element: (
      <g key="linkedin">
        <path d="M21,21H17V14.25C17,13.19 15.81,12.31 14.75,12.31C13.69,12.31 13,13.19 13,14.25V21H9V9H13V11C13.66,9.93 15.36,9.24 16.5,9.24C19,9.24 21,11.28 21,13.75V21M7,21H3V9H7V21M5,3A2,2 0 0,1 7,5A2,2 0 0,1 5,7A2,2 0 0,1 3,5A2,2 0 0,1 5,3Z" />
      </g>
    )
  },
  [IconNames.LockOpen]: {
    element: (
      <g key="lock-open">
        <path d="M18,8A2,2 0 0,1 20,10V20A2,2 0 0,1 18,22H6C4.89,22 4,21.1 4,20V10A2,2 0 0,1 6,8H15V6A3,3 0 0,0 12,3A3,3 0 0,0 9,6H7A5,5 0 0,1 12,1A5,5 0 0,1 17,6V8H18M12,17A2,2 0 0,0 14,15A2,2 0 0,0 12,13A2,2 0 0,0 10,15A2,2 0 0,0 12,17Z" />
      </g>
    )
  },
  [IconNames.Luggage]: {
    element: (
      <g key="luggage">
        <path d="M10.402 2c-.5 0-1 .417-1 1v4h-1.75c-.666 0-1.25.583-1.25 1.25v11.832c0 .667.584 1.25 1.25 1.25h.916c.083.417.418.668.834.668.417 0 .75-.251.834-.668h3.5c.083.417.415.668.832.668s.751-.251.834-.668h.916c.667 0 1.25-.583 1.25-1.25V8.25c.167-.667-.416-1.25-1.082-1.25h-1.75V3c-.084-.583-.5-1-1-1h-3.334zm.75 1.918h1.834c.25 0 .416.164.416.414V7H10.82l-.084-2.668c0-.25.166-.414.416-.414zm-3 5.664h7.834c.333 0 .666.251.666.668 0 .333-.333.668-.666.668H8.152a.657.657 0 0 1-.666-.668c0-.333.333-.668.666-.668z" />
      </g>
    )
  },
  [IconNames.SpecialBags]: {
    element: (
      <g key="bags-special">
        <path d="M11.58,14.38c-0.57,0.57-1.5,0.57-2.07,0c-0.57-0.57-0.57-1.5,0-2.07c0.57-0.57,1.5-0.57,2.07,0 C12.15,12.89,12.15,13.81,11.58,14.38 M9.21,17.86C6.95,17.01,6,14.71,6,14.71l0.8-0.44c0,0,0.88,1.66,2.79,2.82L9.21,17.86L9.21,17.86z M22.03,1.87c-0.06-0.06-0.35-0.33-0.93-0.32c0,0-0.68,0.86-1.67,1.32c0,0-0.28,0.08-0.19,0.44c0,0,0.08,0.33-0.23,0.68 l0,0l-6.02,5.76c-0.74-0.63-2.02-1.51-3.07-1.18c0,0-0.78,0.19-1.35,1.54c0,0-0.57,1.53-1.65,1.67c0,0-0.57,0.06-1.31,0.14c0,0-1.81,0.24-2.83,1.26c0,0-1.43,1.16-1.21,3.31c0,0,0.13,1.47,2,3.48l-0.01,0.01c0.06,0.06,0.12,0.12,0.18,0.17 c0.06,0.06,0.11,0.12,0.17,0.18l0.01-0.01c2.02,1.87,3.48,2,3.48,2c2.15,0.22,3.31-1.21,3.31-1.21c1.01-1.01,1.26-2.83,1.26-2.83c0.07-0.74,0.14-1.31,0.14-1.31c0.14-1.08,1.68-1.65,1.68-1.65c1.35-0.58,1.54-1.35,1.54-1.35c0.33-1.05-0.56-2.33-1.18-3.07 l5.76-6.02l0,0c0.36-0.3,0.68-0.23,0.68-0.23c0.37,0.09,0.44-0.19,0.44-0.19c0.46-0.99,1.32-1.67,1.32-1.67C22.36,2.22,22.09,1.92,22.03,1.87" />
      </g>
    )
  },
  [IconNames.Map]: {
    element: (
      <g key="map">
        <path d="M15,19L9,16.89V5L15,7.11M20.5,3C20.44,3 20.39,3 20.34,3L15,5.1L9,3L3.36,4.9C3.15,4.97 3,5.15 3,5.38V20.5A0.5,0.5 0 0,0 3.5,21C3.55,21 3.61,21 3.66,20.97L9,18.9L15,21L20.64,19.1C20.85,19 21,18.85 21,18.62V3.5A0.5,0.5 0 0,0 20.5,3Z" />
      </g>
    )
  },
  [IconNames.Menu]: {
    element: (
      <g key="menu">
        <path d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" />
      </g>
    )
  },
  [IconNames.Minus]: {
    element: (
      <g key="minus">
        <path d="M19,13H5V11H19V13Z" />
      </g>
    )
  },
  [IconNames.MoreInfoFrequentFlyer]: {
    element: (
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="#396FA5"
          fillRule="nonzero"
          d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z"
        />
      </g>
    )
  },
  [IconNames.MoreInfoTicket]: {
    element: (
      <React.Fragment>
        <defs>
          <path id="a" d="M0 0h24v24H0z" />
        </defs>
        <g fill="none" fillRule="evenodd">
          <path
            fill="#396FA5"
            fillRule="nonzero"
            d="M22 10V6a2 2 0 00-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2a2 2 0 01-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-9 7.5h-2v-2h2v2zm0-4.5h-2v-2h2v2zm0-4.5h-2v-2h2v2z"
          />
        </g>
      </React.Fragment>
    )
  },
  [IconNames.MultiCreditCard]: {
    element: (
      <g key="multi-credit-card">
        <path d="M21,8V6H7V8H21M21,16V11H7V16H21M21,4A2,2 0 0,1 23,6V16A2,2 0 0,1 21,18H7C5.89,18 5,17.1 5,16V6C5,4.89 5.89,4 7,4H21M3,20H18V22H3A2,2 0 0,1 1,20V9H3V20Z" />
      </g>
    )
  },
  [IconNames.OrderBy]: {
    element: (
      <g key="order-by">
        <g
          id="Búsqueda-Branded-fares---Filtros-descolapsados"
          transform="translate(-22.000000, -113.000000)"
        >
          <g id="orderBy" transform="translate(22.000000, 112.000000)">
            <g
              id="arrow-right"
              transform="translate(4.000000, 8.000000) rotate(90.000000) translate(-4.000000, -8.000000) translate(-3.000000, 4.000000)"
            >
              <polygon
                id="Shape"
                points="2,1.2 2,2.7 19.7,2.7 16.1,7.1 17.1,8.2 22.2,1.9 17.1,-4.3 16.1,-3.2 19.7,1.2 				"
              />
            </g>

            <g
              id="arrow-right_1_"
              transform="translate(12.000000, 7.500000) rotate(270.000000) translate(-12.000000, -7.500000) translate(5.000000, 4.000000)"
            >
              <polygon
                id="Shape_1_"
                points="-9.5,9.3 -9.5,10.7 8.2,10.7 4.6,14.5 5.6,15.4 10.7,10 5.6,4.6 4.6,5.5 8.2,9.3 				"
              />
            </g>
          </g>
        </g>
      </g>
    )
  },
  [IconNames.PassengerSeated]: {
    element: (
      <g key="passenger-seated">
        <path d="M5.35,5.64C4.45,5 4.23,3.76 4.86,2.85C5.5,1.95 6.74,1.73 7.65,2.36C8.55,3 8.77,4.24 8.14,5.15C7.5,6.05 6.26,6.27 5.35,5.64M16,19H8.93C7.45,19 6.19,17.92 5.97,16.46L4,7H2L4,16.76C4.37,19.2 6.47,21 8.94,21H16M16.23,15H11.35L10.32,10.9C11.9,11.79 13.6,12.44 15.47,12.12V10C13.84,10.3 12.03,9.72 10.78,8.74L9.14,7.47C8.91,7.29 8.65,7.17 8.38,7.09C8.06,7 7.72,6.97 7.39,7.03H7.37C6.14,7.25 5.32,8.42 5.53,9.64L6.88,15.56C7.16,17 8.39,18 9.83,18H16.68L20.5,21L22,19.5" />
      </g>
    )
  },
  [IconNames.PdfFile]: {
    element: (
      <g key="pdf-file">
        <svg
          width="16"
          height="20"
          viewBox="0 0 16 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.58484 12.7962C9.28987 12.5435 8.99488 12.2275 8.65772 11.8906C8.42595 11.6379 8.17315 11.2798 7.96241 10.9006C8.36278 9.53166 8.55237 8.22567 8.13099 7.59376C7.9414 7.29889 7.64642 7.15137 7.26709 7.15137C6.84572 7.15137 6.52956 7.3409 6.38215 7.69896C6.045 8.45721 6.55073 9.84737 7.1617 10.9847C6.99312 11.5323 6.78252 12.122 6.52956 12.7751C6.382 13.1331 6.21357 13.4912 6.04499 13.8282C4.31718 14.5023 3.26368 15.2604 3.11627 15.9766C3.05307 16.3136 3.15845 16.6085 3.45342 16.8402C3.622 16.9666 3.81159 17.0509 4.02235 17.0509C4.10656 17.0509 4.19092 17.0299 4.27514 17.0087C5.07584 16.798 5.93959 15.6186 6.57173 14.4181C6.95091 14.2706 7.39346 14.1232 7.87803 13.9969C8.44696 13.8283 8.95256 13.702 9.39507 13.6178C10.2168 14.2707 10.9121 14.6288 11.5231 14.6288C11.9866 14.6498 12.3238 14.4813 12.6398 14.1654C13.1033 13.702 12.9138 13.3018 12.8506 13.1964C12.4714 12.6067 11.3126 12.4802 9.58484 12.7962ZM4.06451 16.2714C3.98029 16.2925 3.93811 16.2714 3.89593 16.2504C3.81171 16.1873 3.81171 16.1451 3.83273 16.1029C3.87491 15.8502 4.35948 15.3868 5.41298 14.8813C4.90726 15.6395 4.40151 16.1873 4.06451 16.2714ZM7.05644 7.99387C7.07746 7.9517 7.09862 7.88853 7.2672 7.88853C7.41476 7.88853 7.47796 7.9517 7.52 7.99387C7.70959 8.26773 7.68858 8.96282 7.4568 9.88942C7.09863 9.08916 6.90892 8.33087 7.05644 7.99387ZM7.6464 13.2595C7.43564 13.3227 7.22504 13.3859 7.01426 13.449C7.07746 13.3015 7.14066 13.1542 7.20386 13.0278C7.35142 12.6276 7.51985 12.2274 7.6674 11.8062C7.83598 12.0379 7.98339 12.2486 8.13094 12.3959C8.32053 12.6066 8.51012 12.7962 8.69987 12.9857C8.36271 13.07 8.00456 13.1542 7.64637 13.2595L7.6464 13.2595ZM12.0922 13.6386C11.9446 13.8071 11.755 13.8702 11.5232 13.8702C11.2072 13.8702 10.8279 13.7227 10.3855 13.4279C11.6076 13.2595 12.3028 13.3858 12.0922 13.6386Z"
            fill="#5A5A5A"
          />
          <path
            d="M15.5478 5.0663L10.9334 0.45361C10.6385 0.158742 10.2381 -0.00976562 9.83776 -0.00976562H1.55726C1.1359 -0.00976562 0.756566 0.158753 0.461586 0.45361C0.166614 0.748478 -0.00195312 1.12754 -0.00195312 1.5489V18.441C-0.00195312 19.3047 0.693356 19.9997 1.55726 19.9997H14.4521C15.316 19.9997 16.0113 19.3047 16.0113 18.441V6.16159C16.0113 5.76152 15.8427 5.36133 15.5478 5.06645V5.0663ZM14.6628 5.44535H11.2494C10.8702 5.44535 10.5541 5.12948 10.5541 4.75029L10.5542 1.35922L14.6628 5.44535ZM14.4521 19.0939H1.55724C1.19907 19.0939 0.904108 18.799 0.904108 18.441V1.54882C0.904108 1.38031 0.967306 1.21179 1.0937 1.08545C1.2201 0.959096 1.38868 0.895919 1.55724 0.895919H9.64811V4.75036C9.64811 5.63499 10.3644 6.35108 11.2494 6.35108H15.1052V18.441C15.1052 18.7989 14.8102 19.0939 14.4521 19.0939Z"
            fill="#5A5A5A"
          />
        </svg>
      </g>
    )
  },
  [IconNames.People]: {
    element: (
      <g key="people">
        <path d="M16,13C15.71,13 15.38,13 15.03,13.05C16.19,13.89 17,15 17,16.5V19H23V16.5C23,14.17 18.33,13 16,13M8,13C5.67,13 1,14.17 1,16.5V19H15V16.5C15,14.17 10.33,13 8,13M8,11A3,3 0 0,0 11,8A3,3 0 0,0 8,5A3,3 0 0,0 5,8A3,3 0 0,0 8,11M16,11A3,3 0 0,0 19,8A3,3 0 0,0 16,5A3,3 0 0,0 13,8A3,3 0 0,0 16,11Z" />
      </g>
    )
  },
  [IconNames.PinDrop]: {
    element: (
      <g key="pin-drop">
        <path d="M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11zm-8 0c0-1.1.9-2 2-2s2 .9 2 2-.89 2-2 2c-1.1 0-2-.9-2-2zM5 20v2h14v-2H5z" />
        <path d="M0 0h24v24H0z" fill="none" />
      </g>
    )
  },
  [IconNames.Plus]: {
    element: (
      <g key="plus">
        <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
      </g>
    )
  },
  [IconNames.Reload]: {
    element: (
      <g key="reload">
        <path d="M19,12H22.32L17.37,16.95L12.42,12H16.97C17,10.46 16.42,8.93 15.24,7.75C12.9,5.41 9.1,5.41 6.76,7.75C4.42,10.09 4.42,13.9 6.76,16.24C8.6,18.08 11.36,18.47 13.58,17.41L15.05,18.88C12,20.69 8,20.29 5.34,17.65C2.22,14.53 2.23,9.47 5.35,6.35C8.5,3.22 13.53,3.21 16.66,6.34C18.22,7.9 19,9.95 19,12Z" />
      </g>
    )
  },
  [IconNames.Return]: {
    element: (
      <g key="return">
        <path d="M12,5V1L7,6L12,11V7A6,6 0 0,1 18,13A6,6 0 0,1 12,19A6,6 0 0,1 6,13H4A8,8 0 0,0 12,21A8,8 0 0,0 20,13A8,8 0 0,0 12,5Z" />
      </g>
    )
  },
  [IconNames.Scale]: {
    element: (
      <g key="scale">
        <path d="M12 9.5A2.5 2.5 0 0 0 9.5 12a2.5 2.5 0 0 0 2.5 2.5 2.5 2.5 0 0 0 2.5-2.5A2.5 2.5 0 0 0 12 9.5zM2 11.625v.75h6.5v-.75H2zm13.5 0v.75H22v-.75h-6.5z" />
      </g>
    )
  },
  [IconNames.Seat]: {
    element: (
      <g key="seat">
        <path d="M6.4 2c-.25 0-.584.084-.834.168-1.333.5-1.916 1.916-1.5 3.25l3.5 9.332c.334 1 1.416 1.668 2.416 1.668h2v4.164h-2.75a.57.57 0 0 0-.582.586v.25c0 .333.25.582.582.582H16.9a.57.57 0 0 0 .582-.582v-.25a.57.57 0 0 0-.582-.586h-2.75v-4.164h3.416c1.417 0 2.5-1.084 2.5-2.5 0-1.417-1.083-2.5-2.5-2.5h-.334c-1.083-2.25-3.416-3.75-6.082-3.75h-.834l-1.5-4.086C8.4 2.666 7.483 2 6.4 2zm4.416 6.918h.334c1.916 0 3.666 1 4.666 2.5h-4.084l-.916-2.5z" />
      </g>
    )
  },
  [IconNames.PlainSeat]: {
    element: (
      <g key="plain-seat">
        <path d="M9.82,5.91C9.4,6.08,8.69,6.61,9.17,7.88l2.33,5.51c0.17,0.37,0.54,0.61,0.96,0.62h3.99c0.01,0,0.01,0,0.02,0.01L19.12,18c0.14,0.22,0.36,0.37,0.6,0.44c0.24,0.07,0.5,0.06,0.73-0.05c0.61-0.27,0.77-1.07,0.41-1.62l-2.91-4.45c-0.2-0.31-0.54-0.49-0.9-0.5l-3.1-0.05c-0.01,0-0.02-0.01-0.02-0.01l-2.27-4.89C11.2,5.82,10.25,5.75,9.82,5.91zM9.41,5.43c0.86,0.25,1.76-0.24,2.02-1.09c0.25-0.85-0.24-1.74-1.1-1.98C9.46,2.11,8.56,2.6,8.31,3.45C8.06,4.29,8.55,5.18,9.41,5.43z" />
        <path d="M16.48,16.22c0-0.37-0.31-0.67-0.68-0.67h-0.02l-5.48,0l-0.02-0.05L6.19,4.76c0,0,0-0.01,0-0.01L5.99,4.25C5.86,3.9,5.47,3.72,5.12,3.85L3.43,4.4C3.08,4.52,2.9,4.91,3.03,5.26l0.01,0.02l3.92,10.29h0L8,18.35c0.01,0.03,0.01,0.05,0.02,0.07c0,0.02,0.01,0.05,0.01,0.08l0.02,2.64c0,0.01,0.01,0.02,0.02,0.02h8.39c0.01,0,0.02-0.01,0.02-0.02v-3.59h0L16.48,16.22z" />
        <path d="M16.67,8.15h-0.54c-0.76,0-1.38-0.62-1.38-1.38V5.16c0-0.76,0.62-1.38,1.38-1.38h0.54c0.76,0,1.38,0.62,1.38,1.38v1.62C18.05,7.53,17.43,8.15,16.67,8.15z" />
      </g>
    )
  },
  [IconNames.Search]: {
    element: (
      <g key="seat">
        <path
          d="M625.138889,292 C628.529304,292 631.277778,294.748474 631.277778,298.138889 C631.277778,299.659444 630.720556,301.057222 629.804444,302.133889 L630.059444,302.388889 L630.805556,302.388889 L635.527778,307.111111 L634.111111,308.527778 L629.388889,303.805556 L629.388889,303.059444 L629.133889,302.804444 C628.057222,303.720556 626.659444,304.277778 625.138889,304.277778 C621.748474,304.277778 619,301.529304 619,298.138889 C619,294.748474 621.748474,292 625.138889,292 Z M625.138889,293.888889 C622.777778,293.888889 620.888889,295.777778 620.888889,298.138889 C620.888889,300.5 622.777778,302.388889 625.138889,302.388889 C627.5,302.388889 629.388889,300.5 629.388889,298.138889 C629.388889,295.777778 627.5,293.888889 625.138889,293.888889 Z"
          transform="translate(-615 -288)"
        />
      </g>
    )
  },
  [IconNames.Settings]: {
    element: (
      <g key="settings">
        <path d="M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.21,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.21,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.67 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z" />
      </g>
    )
  },
  [IconNames.TagMultiple]: {
    element: (
      <g key="tag-multiple">
        <path d="M5.5,9A1.5,1.5 0 0,0 7,7.5A1.5,1.5 0 0,0 5.5,6A1.5,1.5 0 0,0 4,7.5A1.5,1.5 0 0,0 5.5,9M17.41,11.58C17.77,11.94 18,12.44 18,13C18,13.55 17.78,14.05 17.41,14.41L12.41,19.41C12.05,19.77 11.55,20 11,20C10.45,20 9.95,19.78 9.58,19.41L2.59,12.42C2.22,12.05 2,11.55 2,11V6C2,4.89 2.89,4 4,4H9C9.55,4 10.05,4.22 10.41,4.58L17.41,11.58M13.54,5.71L14.54,4.71L21.41,11.58C21.78,11.94 22,12.45 22,13C22,13.55 21.78,14.05 21.42,14.41L16.04,19.79L15.04,18.79L20.75,13L13.54,5.71Z" />
      </g>
    )
  },
  [IconNames.TagPlus]: {
    element: (
      <g key="tag-plus">
        <path d="M21.41,11.58L12.41,2.58C12.04,2.21 11.53,2 11,2H4A2,2 0 0,0 2,4V11C2,11.53 2.21,12.04 2.59,12.41L3,12.81C3.9,12.27 4.94,12 6,12A6,6 0 0,1 12,18C12,19.06 11.72,20.09 11.18,21L11.58,21.4C11.95,21.78 12.47,22 13,22C13.53,22 14.04,21.79 14.41,21.41L21.41,14.41C21.79,14.04 22,13.53 22,13C22,12.47 21.79,11.96 21.41,11.58M5.5,7A1.5,1.5 0 0,1 4,5.5A1.5,1.5 0 0,1 5.5,4A1.5,1.5 0 0,1 7,5.5A1.5,1.5 0 0,1 5.5,7M10,19H7V22H5V19H2V17H5V14H7V17H10V19Z" />
      </g>
    )
  },
  [IconNames.Ticket]: {
    element: (
      <g key="ticket">
        <path d="M4.408 6.191C3.08 6.191 2 7.104 2 8.266v7.386c0 1.162 1.079 2.157 2.406 2.157h15.186c1.328 0 2.408-.995 2.408-2.157V8.266c-.083-1.162-1.163-2.075-2.49-2.075H4.408zm-.002 1.163v.001h15.186c.663 0 1.162.415 1.162.913v7.384h-.084c0 .497-.497.912-1.162.912h-15.1c-.664 0-1.162-.414-1.162-.912V8.266c0-.497.496-.912 1.16-.912zm2.987.996v1.08h1.244V8.35H7.393zm9.777 1.21a.752.752 0 0 0-.027.002.698.698 0 0 0-.456.198l-.914.914-2.822-.83-.496.496c-.083.083-.083.168 0 .168l2.24 1.246-1.162 1.158-.746-.166-.332.334v.164l1.66 1.66h.166l.332-.332-.168-.912 1.162-1.162 1.247 2.324c.083.083.166.083.166 0l.496-.5-.828-2.82.912-.912a.651.651 0 0 0 0-.914.752.752 0 0 0-.43-.115zm-9.775.864v1.078h1.244v-1.078H7.395zm0 2.074v1.078h1.244v-1.078H7.395zm0 2.074v1.08h1.244v-1.08H7.395z" />
      </g>
    )
  },
  [IconNames.TicketPercent]: {
    element: (
      <g key="ticket-percent">
        <path d="M4,4A2,2 0 0,0 2,6V10C3.11,10 4,10.9 4,12A2,2 0 0,1 2,14V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V14A2,2 0 0,1 20,12C20,10.89 20.9,10 22,10V6C22,4.89 21.1,4 20,4H4M15.5,7L17,8.5L8.5,17L7,15.5L15.5,7M8.81,7.04C9.79,7.04 10.58,7.83 10.58,8.81A1.77,1.77 0 0,1 8.81,10.58C7.83,10.58 7.04,9.79 7.04,8.81A1.77,1.77 0 0,1 8.81,7.04M15.19,13.42C16.17,13.42 16.96,14.21 16.96,15.19A1.77,1.77 0 0,1 15.19,16.96C14.21,16.96 13.42,16.17 13.42,15.19A1.77,1.77 0 0,1 15.19,13.42Z" />
      </g>
    )
  },
  [IconNames.TicketStar]: {
    element: (
      <g key="ticket-star">
        <path d="M15.58,16.8L12,14.5L8.42,16.8L9.5,12.68L6.21,10L10.46,9.74L12,5.8L13.54,9.74L17.79,10L14.5,12.68M20,12C20,10.89 20.9,10 22,10V6C22,4.89 21.1,4 20,4H4A2,2 0 0,0 2,6V10C3.11,10 4,10.9 4,12A2,2 0 0,1 2,14V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V14A2,2 0 0,1 20,12Z" />
      </g>
    )
  },
  [IconNames.Twitter]: {
    element: (
      <g key="twitter">
        <path d="M22.46,6C21.69,6.35 20.86,6.58 20,6.69C20.88,6.16 21.56,5.32 21.88,4.31C21.05,4.81 20.13,5.16 19.16,5.36C18.37,4.5 17.26,4 16,4C13.65,4 11.73,5.92 11.73,8.29C11.73,8.63 11.77,8.96 11.84,9.27C8.28,9.09 5.11,7.38 3,4.79C2.63,5.42 2.42,6.16 2.42,6.94C2.42,8.43 3.17,9.75 4.33,10.5C3.62,10.5 2.96,10.3 2.38,10C2.38,10 2.38,10 2.38,10.03C2.38,12.11 3.86,13.85 5.82,14.24C5.46,14.34 5.08,14.39 4.69,14.39C4.42,14.39 4.15,14.36 3.89,14.31C4.43,16 6,17.26 7.89,17.29C6.43,18.45 4.58,19.13 2.56,19.13C2.22,19.13 1.88,19.11 1.54,19.07C3.44,20.29 5.7,21 8.12,21C16,21 20.33,14.46 20.33,8.79C20.33,8.6 20.33,8.42 20.32,8.23C21.16,7.63 21.88,6.87 22.46,6Z" />
      </g>
    )
  },
  [IconNames.VipLounge]: {
    element: (
      <g>
        <path d="M11.65,1.59c1.89,2.06-2.22,4.19-0.5,5.75" />
        <path d="M8.61,1.59c1.9,2.07-2.23,4.21-0.5,5.77" />
        <path d="M14.57,1.59c1.9,2.07-2.23,4.21-0.5,5.77" />
        <path d="M17.7,10.63c-0.07-0.51-0.3-0.97-0.65-1.32c-0.41-0.42-1-0.68-1.66-0.68H7c-0.65,0-1.25,0.25-1.67,0.67c-0.42,0.42-0.67,1-0.67,1.65c0,0.07,0,0.15,0.01,0.24l0.86,9.02c0.13,1.38,1.33,2.46,2.72,2.47h5.89c1.39-0.01,2.58-1.09,2.72-2.47l0.28-2.98c1.73-0.14,3.08-1.59,3.08-3.35C20.23,12.31,19.15,10.99,17.7,10.63z M7.55,15.11l3.67-0.66c0.58-0.1,0.67-0.35,0.19-0.53c-0.86-0.32-2.5-0.83-2.5-0.83l5.15,0.32c0.63,0.04,0.67,0.46,0.21,0.75l-0.49,0.32c-0.1,0.07-0.12,0.21-0.05,0.31c0.07,0.1,0.21,0.12,0.31,0.05c0.09-0.06,0.11-0.18,0.07-0.28h0.33c0.6,0,0.85,0.28,0.85,0.54H7.55z" />
      </g>
    )
  },
  [IconNames.WalletTravel]: {
    element: (
      <g key="wallet-travel">
        <path d="M20,14H4V8H7V10H9V8H15V10H17V8H20M20,19H4V17H20M9,4H15V6H9M20,6H17V4C17,2.89 16.11,2 15,2H9C7.89,2 7,2.89 7,4V6H4C2.89,6 2,6.89 2,8V19C2,20.11 2.89,21 4,21H20C21.11,21 22,20.11 22,19V8C22,6.89 21.11,6 20,6Z" />
      </g>
    )
  },
  [IconNames.Youtube]: {
    element: (
      <g key="youtube">
        <path d="M10,15L15.19,12L10,9V15M21.56,7.17C21.69,7.64 21.78,8.27 21.84,9.07C21.91,9.87 21.94,10.56 21.94,11.16L22,12C22,14.19 21.84,15.8 21.56,16.83C21.31,17.73 20.73,18.31 19.83,18.56C19.36,18.69 18.5,18.78 17.18,18.84C15.88,18.91 14.69,18.94 13.59,18.94L12,19C7.81,19 5.2,18.84 4.17,18.56C3.27,18.31 2.69,17.73 2.44,16.83C2.31,16.36 2.22,15.73 2.16,14.93C2.09,14.13 2.06,13.44 2.06,12.84L2,12C2,9.81 2.16,8.2 2.44,7.17C2.69,6.27 3.27,5.69 4.17,5.44C4.64,5.31 5.5,5.22 6.82,5.16C8.12,5.09 9.31,5.06 10.41,5.06L12,5C16.19,5 18.8,5.16 19.83,5.44C20.73,5.69 21.31,6.27 21.56,7.17Z" />
      </g>
    )
  },
  [IconNames.Share]: {
    element: (
      <g key="share">
        <path d="M18,16.08C17.24,16.08 16.56,16.38 16.04,16.85L8.91,12.7C8.96,12.47 9,12.24 9,12C9,11.76 8.96,11.53 8.91,11.3L15.96,7.19C16.5,7.69 17.21,8 18,8A3,3 0 0,0 21,5A3,3 0 0,0 18,2A3,3 0 0,0 15,5C15,5.24 15.04,5.47 15.09,5.7L8.04,9.81C7.5,9.31 6.79,9 6,9A3,3 0 0,0 3,12A3,3 0 0,0 6,15C6.79,15 7.5,14.69 8.04,14.19L15.16,18.34C15.11,18.55 15.08,18.77 15.08,19C15.08,20.61 16.39,21.91 18,21.91C19.61,21.91 20.92,20.61 20.92,19A2.92,2.92 0 0,0 18,16.08Z" />
      </g>
    )
  },
  [IconNames.ChildFriendly]: {
    element: (
      <g key="child-friendly">
        <path d="M13 2v8h8c0-4.42-3.58-8-8-8zm6.32 13.89A7.948 7.948 0 0 0 21 11H6.44l-.95-2H2v2h2.22s1.89 4.07 2.12 4.42c-1.1.59-1.84 1.75-1.84 3.08C4.5 20.43 6.07 22 8 22c1.76 0 3.22-1.3 3.46-3h2.08c.24 1.7 1.7 3 3.46 3 1.93 0 3.5-1.57 3.5-3.5 0-1.04-.46-1.97-1.18-2.61zM8 20c-.83 0-1.5-.67-1.5-1.5S7.17 17 8 17s1.5.67 1.5 1.5S8.83 20 8 20zm9 0c-.83 0-1.5-.67-1.5-1.5S16.17 17 17 17s1.5.67 1.5 1.5S17.83 20 17 20z" />
      </g>
    )
  },
  [IconNames.ARPlusCard]: {
    element: (
      <g key="arplus-card">
        <path d="M 1.5 0 h 15 c 0.787 0 1.5 0.739 1.5 1.556 v 10.888 c 0 0.817 -0.713 1.556 -1.5 1.556 h -15 C 0.713 14 0 13.261 0 12.444 V 1.556 C 0 0.739 0.713 0 1.5 0 Z m 9 2.333 v 0.778 h 6 v -0.778 h -6 Z m 0 1.556 v 0.778 h 6 v -0.778 h -6 Z m 0 1.555 v 0.778 h 5.25 v -0.778 H 10.5 Z M 6 8.486 c -1.5 0 -4.5 0.847 -4.5 2.403 v 0.778 h 9 v -0.778 c 0 -1.556 -3 -2.403 -4.5 -2.403 Z m 0 -6.153 c -1.243 0 -2.25 1.045 -2.25 2.334 C 3.75 5.955 4.757 7 6 7 s 2.25 -1.045 2.25 -2.333 c 0 -1.289 -1.007 -2.334 -2.25 -2.334 Z" />
      </g>
    )
  },
  [IconNames.WalletGrey]: {
    element: (
      <g key="wallet-icon">
        <path d="M14.147 11.667v.777c0 .856-.707 1.556-1.572 1.556H1.572C.7 14 0 13.3 0 12.444V1.556C0 .7.7 0 1.572 0h11.003c.865 0 1.572.7 1.572 1.556v.777H7.074c-.873 0-1.572.7-1.572 1.556v6.222c0 .856.7 1.556 1.572 1.556h7.073zM7.074 10.11h7.86V3.89h-7.86v6.222zm3.144-1.944A1.171 1.171 0 0 1 9.038 7c0-.646.527-1.167 1.18-1.167.652 0 1.178.521 1.178 1.167s-.526 1.167-1.178 1.167z" />
      </g>
    )
  },
  [IconNames.StarShape]: {
    element: (
      <g>
        <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z" />
      </g>
    )
  },
  [IconNames.LibraryAdd]: {
    element: (
      <g key="library_add">
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z" />
      </g>
    )
  },
  [IconNames.SwapHorizontalCircle]: {
    element: (
      <g key="swap_horizontal_circle">
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12s4.48 10 10 10 10-4.48 10-10zm-7-5.5l3.5 3.5-3.5 3.5V11h-4V9h4V6.5zm-6 11L5.5 14 9 10.5V13h4v2H9v2.5z" />
      </g>
    )
  },
  [IconNames.ShoppingCart]: {
    element: (
      <g key="shopping_cart">
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" />
      </g>
    )
  },
  [IconNames.TicketStar]: {
    element: (
      <g key="ticket-star">
        <path d="M15.58,16.8L12,14.5L8.42,16.8L9.5,12.68L6.21,10L10.46,9.74L12,5.8L13.54,9.74L17.79,10L14.5,12.68M20,12C20,10.89 20.9,10 22,10V6C22,4.89 21.1,4 20,4H4A2,2 0 0,0 2,6V10C3.11,10 4,10.9 4,12A2,2 0 0,1 2,14V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V14A2,2 0 0,1 20,12Z" />
      </g>
    )
  },
  [IconNames.Link]: {
    element: (
      <g key="link">
        <path d="M10.59,13.41C11,13.8 11,14.44 10.59,14.83C10.2,15.22 9.56,15.22 9.17,14.83C7.22,12.88 7.22,9.71 9.17,7.76V7.76L12.71,4.22C14.66,2.27 17.83,2.27 19.78,4.22C21.73,6.17 21.73,9.34 19.78,11.29L18.29,12.78C18.3,11.96 18.17,11.14 17.89,10.36L18.36,9.88C19.54,8.71 19.54,6.81 18.36,5.64C17.19,4.46 15.29,4.46 14.12,5.64L10.59,9.17C9.41,10.34 9.41,12.24 10.59,13.41M13.41,9.17C13.8,8.78 14.44,8.78 14.83,9.17C16.78,11.12 16.78,14.29 14.83,16.24V16.24L11.29,19.78C9.34,21.73 6.17,21.73 4.22,19.78C2.27,17.83 2.27,14.66 4.22,12.71L5.71,11.22C5.7,12.04 5.83,12.86 6.11,13.65L5.64,14.12C4.46,15.29 4.46,17.19 5.64,18.36C6.81,19.54 8.71,19.54 9.88,18.36L13.41,14.83C14.59,13.66 14.59,11.76 13.41,10.59C13,10.2 13,9.56 13.41,9.17Z" />
      </g>
    )
  },
  [IconNames.PaperClip]: {
    element: (
      <g key="paper-clip">
        <path d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"></path>
      </g>
    )
  },
  [IconNames.ToDo]: {
    element: (
      <g key="to-do">
        <path d="M3,5H9V11H3V5M5,7V9H7V7H5M11,7H21V9H11V7M11,15H21V17H11V15M5,20L1.5,16.5L2.91,15.09L5,17.17L9.59,12.59L11,14L5,20Z" />
      </g>
    )
  },
  [IconNames.Receipt]: {
    element: (
      <g key="receipt">
        <path d="M4.5 20.5L3 22V2L4.5 3.5L6 2L7.5 3.5L9 2L10.5 3.5L12 2L13.5 3.5L15 2L16.5 3.5L18 2L19.5 3.5L21 2V22L19.5 20.5L18 22L16.5 20.5L15 22L13.5 20.5L12 22L10.5 20.5L9 22L7.5 20.5L6 22L4.5 20.5ZM18 7V9H6V7H18ZM6 11V13H18V11H6ZM6 15V17H18V15H6Z" />
      </g>
    )
  },
  [IconNames.Local_hospital]: {
    element: (
      <g key="local-hospital">
        <path d="M21 3H3.01L3 21H21V3ZM18 14H14V18H10V14H6V10H10V6H14V10H18V14Z" />
      </g>
    )
  },
  [IconNames.DownloadOutline]: {
    element: (
      <svg viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.479 13.2855L6.86359 9.6701L7.74505 8.8624L9.87484 10.9922V3.67969H11.0832V10.9922L13.213 8.8624L14.0944 9.6701L10.479 13.2855ZM6.38171 16.3464C5.89477 16.3464 5.4872 16.1811 5.159 15.8507C4.83067 15.5205 4.6665 15.1119 4.6665 14.6251V13.6059H5.87484V14.6251C5.87484 14.7534 5.92824 14.871 6.03505 14.9778C6.14185 15.0846 6.25942 15.138 6.38775 15.138H14.6119C14.7403 15.138 14.8578 15.0846 14.9646 14.9778C15.0714 14.871 15.1248 14.7534 15.1248 14.6251V13.6059H16.3332V14.6251C16.3332 15.1157 16.1679 15.5252 15.8373 15.8536C15.5068 16.1821 15.098 16.3464 14.6111 16.3464H6.38171Z"
          fill="#396FA5"
        />
      </svg>
    )
  },
  [IconNames.Star]: {
    element: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M12,15.39L8.24,17.66L9.23,13.38L5.91,10.5L10.29,10.13L12,6.09L13.71,10.13L18.09,10.5L14.77,13.38L15.76,17.66M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z" />
      </svg>
    )
  },
  [IconNames.A]: {
    element: (
      <g key="box-a">
        <path d="M9.93 13.5h4.14L12 7.98zM20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-4.05 16.5l-1.14-3H9.17l-1.12 3H5.96l5.11-13h1.86l5.11 13h-2.09z" />
      </g>
    )
  },
  [IconNames.AccountBalance]: {
    element: (
      <g key="account-balance">
        <path d="M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 22h19v-3H2v3zm14-12v7h3v-7h-3zm-4.5-9L2 6v2h19V6l-9.5-5z" />
      </g>
    )
  },
  [IconNames.AccountBalanceWallet]: {
    element: (
      <g key="account-balance-wallet">
        <path d="M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" />
        <use transform="translate(-58 -610)" href="#account-balance-wallet_icon-a" />
      </g>
    )
  },
  [IconNames.AirlineSeatRecline]: {
    element: (
      <g key="airline-seat-recline">
        <defs>
          <path
            id="airline_seat_recline_extra_icon-a"
            d="M62.35,472.64 C61.45,472 61.23,470.76 61.86,469.85 C62.49,468.95 63.74,468.73 64.65,469.36 C65.55,470 65.77,471.24 65.14,472.15 C64.5,473.05 63.26,473.27 62.35,472.64 Z M73,486 L65.93,486 C64.45,486 63.19,484.92 62.97,483.46 L61,474 L59,474 L60.99,483.76 C61.37,486.2 63.47,488 65.94,488 L73,488 L73,486 Z M73.23,482 L68.35,482 L67.32,477.9 C68.9,478.79 70.6,479.44 72.47,479.12 L72.47,476.99 C70.84,477.3 69.03,476.72 67.78,475.74 L66.14,474.47 C65.91,474.29 65.65,474.17 65.38,474.09 C65.06,474 64.72,473.97 64.39,474.03 L64.37,474.03 C63.14,474.25 62.32,475.42 62.53,476.64 L63.88,482.56 C64.16,483.98 65.39,485 66.83,485 L73.68,485 L77.5,488 L79,486.5 L73.23,482 Z"
          />
        </defs>
        <use transform="translate(-59 -469)" href="#airline_seat_recline_extra_icon-a" />
      </g>
    )
  },
  [IconNames.AirplaneFlying]: {
    element: (
      <g key="airplane-icon">
        <defs>
          <path
            id="airplane_icon-a"
            d="M74.18,554 L75.67,552.51 L73.43,542.81 L77.53,538.71 C78.15,538.09 78.15,537.09 77.53,536.47 C76.91,535.85 75.91,535.85 75.29,536.47 L71.19,540.57 L61.49,538.33 L60,539.82 L67.84,543.92 L63.74,548.02 L61.13,547.65 L60,548.78 L63.36,550.65 L65.22,554 L66.34,552.88 L65.97,550.27 L70.07,546.17 L74.18,554 Z"
          />
        </defs>
        <use transform="translate(-60 -536)" href="#airplane_icon-a" />
      </g>
    )
  },
  [IconNames.ArrowLeftRight]: {
    element: (
      <g key="arrow-left-right">
        <path d="M21,9L17,5V8H10V10H17V13M7,11L3,15L7,19V16H14V14H7V11Z" />
      </g>
    )
  },
  [IconNames.ArrowUp]: {
    element: (
      <g key="arrow-up">
        <path d="M13,20H11V8L5.5,13.5L4.08,12.08L12,4.16L19.92,12.08L18.5,13.5L13,8V20Z" />
      </g>
    )
  },
  [IconNames.Assignment]: {
    element: (
      <g key="assignment-icon">
        <defs>
          <path
            id="assignment_icon-a"
            d="M76,544 L71.82,544 C71.4,542.84 70.3,542 69,542 C67.7,542 66.6,542.84 66.18,544 L62,544 C60.9,544 60,544.9 60,546 L60,560 C60,561.1 60.9,562 62,562 L76,562 C77.1,562 78,561.1 78,560 L78,546 C78,544.9 77.1,544 76,544 Z M69,544 C69.55,544 70,544.45 70,545 C70,545.55 69.55,546 69,546 C68.45,546 68,545.55 68,545 C68,544.45 68.45,544 69,544 Z M71,558 L64,558 L64,556 L71,556 L71,558 Z M74,554 L64,554 L64,552 L74,552 L74,554 Z M74,550 L64,550 L64,548 L74,548 L74,550 Z"
          />
        </defs>
        <use transform="translate(-57 -542)" href="#assignment_icon-a" />
      </g>
    )
  },
  [IconNames.AttachMoney]: {
    element: (
      <g key="attach-money-icon">
        <defs>
          <path
            id="attach_money_icon-a"
            d="M68.8,149.9 C66.53,149.31 65.8,148.7 65.8,147.75 C65.8,146.66 66.81,145.9 68.5,145.9 C70.28,145.9 70.94,146.75 71,148 L73.21,148 C73.14,146.28 72.09,144.7 70,144.19 L70,142 L67,142 L67,144.16 C65.06,144.58 63.5,145.84 63.5,147.77 C63.5,150.08 65.41,151.23 68.2,151.9 C70.7,152.5 71.2,153.38 71.2,154.31 C71.2,155 70.71,156.1 68.5,156.1 C66.44,156.1 65.63,155.18 65.52,154 L63.32,154 C63.44,156.19 65.08,157.42 67,157.83 L67,160 L70,160 L70,157.85 C71.95,157.48 73.5,156.35 73.5,154.3 C73.5,151.46 71.07,150.49 68.8,149.9 Z"
          />
        </defs>
        <use transform="translate(-63 -139)" href="#attach_money_icon-a" />
      </g>
    )
  },
  [IconNames.Block]: {
    element: (
      <g key="block">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z" />
      </g>
    )
  },
  [IconNames.BusinessCenter]: {
    element: (
      <g key="business-center-icon">
        <defs>
          <path
            id="business_center_icon-a"
            d="M67,417 L67,416 L60.01,416 L60,420 C60,421.11 60.89,422 62,422 L76,422 C77.11,422 78,421.11 78,420 L78,416 L71,416 L71,417 L67,417 Z M77,408 L72.99,408 L72.99,406 L70.99,404 L66.99,404 L64.99,406 L64.99,408 L61,408 C59.9,408 59,408.9 59,410 L59,413 C59,414.11 59.89,415 61,415 L67,415 L67,413 L71,413 L71,415 L77,415 C78.1,415 79,414.1 79,413 L79,410 C79,408.9 78.1,408 77,408 Z M71,408 L67,408 L67,406 L71,406 L71,408 Z"
          />
        </defs>
        <use transform="translate(-59 -404)" href="#business_center_icon-a" />
      </g>
    )
  },
  [IconNames.Cancelled]: {
    element: (
      <g key="cancelled">
        <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
          <mask id="mask0_977_59361" maskUnits="userSpaceOnUse" x="2" y="2" width="22" height="22">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.0003 2.16675C7.02033 2.16675 2.16699 7.02008 2.16699 13.0001C2.16699 18.9801 7.02033 23.8334 13.0003 23.8334C18.9803 23.8334 23.8337 18.9801 23.8337 13.0001C23.8337 7.02008 18.9803 2.16675 13.0003 2.16675ZM13.0003 21.6667C8.21199 21.6667 4.33366 17.7884 4.33366 13.0001C4.33366 10.9959 5.01616 9.15425 6.16449 7.69175L18.3087 19.8359C16.8462 20.9842 15.0045 21.6667 13.0003 21.6667ZM7.69199 6.16425L19.8362 18.3084C20.9845 16.8459 21.667 15.0042 21.667 13.0001C21.667 8.21175 17.7887 4.33341 13.0003 4.33341C10.9962 4.33341 9.15449 5.01591 7.69199 6.16425Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_977_59361)">
            <rect width="26" height="26" fill="#396FA5" />
          </g>
        </svg>
      </g>
    )
  },
  [IconNames.Cached]: {
    element: (
      <g key="cached">
        <path d="M19 8l-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46C8.97 19.54 10.43 20 12 20c4.42 0 8-3.58 8-8h3l-4-4zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46C15.03 4.46 13.57 4 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4H6z" />
      </g>
    )
  },
  [IconNames.CalendarToday]: {
    element: (
      <g key="calendar-today-icon">
        <defs>
          <path
            id="calendar_today_icon-a"
            d="M77,323 L76,323 L76,321 L74,321 L74,323 L64,323 L64,321 L62,321 L62,323 L61,323 C59.9,323 59,323.9 59,325 L59,341 C59,342.1 59.9,343 61,343 L77,343 C78.1,343 79,342.1 79,341 L79,325 C79,323.9 78.1,323 77,323 Z M77,341 L61,341 L61,328 L77,328 L77,341 Z"
          />
        </defs>
        <use transform="translate(-59 -321)" href="#calendar_today_icon-a" />
      </g>
    )
  },
  [IconNames.Clear]: {
    element: (
      <g key="clean">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
      </g>
    )
  },
  [IconNames.Cloud_upload]: {
    element: (
      <g key="Cloud_upload">
        <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z" />
        <path d="M0 0h24v24H0z" fill="none" />
      </g>
    )
  },
  [IconNames.CloseCircle]: {
    element: (
      <g key="close-circle">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.5209 6.44984C12.1893 3.11822 6.78143 3.11822 3.44982 6.44984C0.118209 9.78145 0.118209 15.1893 3.44982 18.5209C6.78143 21.8525 12.1893 21.8525 15.5209 18.5209C18.8525 15.1893 18.8525 9.78145 15.5209 6.44984ZM13.1067 10.0712L11.8996 8.86406L9.48535 11.2783L7.07114 8.86406L5.86403 10.0712L8.27825 12.4854L5.86403 14.8996L7.07114 16.1067L9.48535 13.6925L11.8996 16.1067L13.1067 14.8996L10.6925 12.4854L13.1067 10.0712ZM4.65693 7.65698C1.99526 10.3186 1.99526 14.6522 4.65693 17.3138C7.3186 19.9755 11.6521 19.9755 14.3138 17.3138C16.9754 14.6522 16.9754 10.3186 14.3138 7.65698C11.6521 4.99531 7.3186 4.99531 4.65693 7.65698Z"
          fill="#396FA5"
        />{' '}
      </g>
    )
  },
  [IconNames.CloseCircleNonFill]: {
    element: (
      <g key="close-circle-non-fill">
        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.5209 6.44984C12.1893 3.11822 6.78143 3.11822 3.44982 6.44984C0.118209 9.78145 0.118209 15.1893 3.44982 18.5209C6.78143 21.8525 12.1893 21.8525 15.5209 18.5209C18.8525 15.1893 18.8525 9.78145 15.5209 6.44984ZM13.1067 10.0712L11.8996 8.86406L9.48535 11.2783L7.07114 8.86406L5.86403 10.0712L8.27825 12.4854L5.86403 14.8996L7.07114 16.1067L9.48535 13.6925L11.8996 16.1067L13.1067 14.8996L10.6925 12.4854L13.1067 10.0712ZM4.65693 7.65698C1.99526 10.3186 1.99526 14.6522 4.65693 17.3138C7.3186 19.9755 11.6521 19.9755 14.3138 17.3138C16.9754 14.6522 16.9754 10.3186 14.3138 7.65698C11.6521 4.99531 7.3186 4.99531 4.65693 7.65698Z"
            fill="#396FA5"
          />
        </svg>
      </g>
    )
  },
  [IconNames.Company]: {
    element: (
      <g key="company">
        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.5 21C4.08333 21 3.72917 20.8542 3.4375 20.5625C3.14583 20.2708 3 19.9167 3 19.5V8.625C3 8.20833 3.14583 7.85417 3.4375 7.5625C3.72917 7.27083 4.08333 7.125 4.5 7.125H7.125V4.5C7.125 4.08333 7.27083 3.72917 7.5625 3.4375C7.85417 3.14583 8.20833 3 8.625 3H15.375C15.7917 3 16.1458 3.14583 16.4375 3.4375C16.7292 3.72917 16.875 4.08333 16.875 4.5V11.25H19.5C19.9167 11.25 20.2708 11.3958 20.5625 11.6875C20.8542 11.9792 21 12.3333 21 12.75V19.5C21 19.9167 20.8542 20.2708 20.5625 20.5625C20.2708 20.8542 19.9167 21 19.5 21H13.325V16.875H10.675V21H4.5ZM4.5 19.5H7.125V16.875H4.5V19.5ZM4.5 15.375H7.125V12.75H4.5V15.375ZM4.5 11.25H7.125V8.625H4.5V11.25ZM8.625 15.375H11.25V12.75H8.625V15.375ZM8.625 11.25H11.25V8.625H8.625V11.25ZM8.625 7.125H11.25V4.5H8.625V7.125ZM12.75 15.375H15.375V12.75H12.75V15.375ZM12.75 11.25H15.375V8.625H12.75V11.25ZM12.75 7.125H15.375V4.5H12.75V7.125ZM16.875 19.5H19.5V16.875H16.875V19.5ZM16.875 15.375H19.5V12.75H16.875V15.375Z" />
        </svg>
      </g>
    )
  },
  [IconNames.Competence]: {
    element: (
      <g key="competence">
        <svg width="23" height="22" viewBox="0 0 23 22" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.520269 21.6282H6.6555C6.90223 21.6282 7.10325 21.4271 7.10325 21.1804L7.10341 12.8471C7.10341 12.6004 6.90237 12.3994 6.65566 12.3994L0.52002 12.3992C0.273295 12.3992 0.0722656 12.6003 0.0722656 12.847V21.1798C0.0722656 21.4267 0.273307 21.6279 0.52002 21.6279L0.520269 21.6282ZM15.8814 15.0368H22.0166C22.2633 15.0368 22.4643 15.2379 22.4643 15.4846V21.1805C22.4643 21.4272 22.2633 21.6283 22.0166 21.6283L15.8814 21.6286C15.6346 21.6286 15.4336 21.4276 15.4336 21.1808V15.4849C15.4336 15.2383 15.635 15.0368 15.8814 15.0368ZM14.2692 8.86694H8.26806C8.02133 8.86694 7.8203 9.06799 7.8203 9.3147V21.1805C7.8203 21.4272 8.02135 21.6283 8.26806 21.6283H14.2692C14.516 21.6283 14.717 21.4272 14.717 21.1805V9.31511C14.717 9.06838 14.5158 8.86719 14.2691 8.86719L14.2692 8.86694Z"
          />
          <path d="M12.4519 2.31347L11.655 0.111571C11.601 -0.0371904 11.3988 -0.0371904 11.3448 0.111571L10.5479 2.31347C10.5241 2.37943 10.4681 2.422 10.4007 2.42551L8.15807 2.54013C8.00556 2.54831 7.94335 2.7497 8.06219 2.85004L9.81231 4.3255C9.86493 4.36994 9.88611 4.43824 9.8685 4.50677L9.27942 6.77957C9.23906 6.93418 9.40272 7.05861 9.53049 6.9709L11.409 5.68094C11.4652 5.64212 11.5341 5.64212 11.5908 5.68094L13.4693 6.9709C13.5971 7.05862 13.7603 6.93441 13.7204 6.77957L13.1313 4.50677C13.1135 4.43871 13.1349 4.36995 13.1875 4.3255L14.9376 2.85004C15.0569 2.74947 14.9942 2.54785 14.8417 2.54013L12.5991 2.42551C12.5315 2.422 12.476 2.37944 12.4519 2.31347Z" />
        </svg>
      </g>
    )
  },
  [IconNames.Copy]: {
    element: (
      <g key="copy">
        <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm-1 4l6 6v10c0 1.1-.9 2-2 2H7.99C6.89 23 6 22.1 6 21l.01-14c0-1.1.89-2 1.99-2h7zm-1 7h5.5L14 6.5V12z" />
      </g>
    )
  },
  [IconNames.Delete]: {
    element: (
      <g key="delete">
        <path d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" />
      </g>
    )
  },
  [IconNames.Description]: {
    element: (
      <g key="description-icon">
        <defs>
          <path
            id="description_icon-a"
            d="M71,610 L63,610 C61.9,610 61.01,610.9 61.01,612 L61,628 C61,629.1 61.89,630 62.99,630 L75,630 C76.1,630 77,629.1 77,628 L77,616 L71,610 Z M73,626 L65,626 L65,624 L73,624 L73,626 Z M73,622 L65,622 L65,620 L73,620 L73,622 Z M70,617 L70,611.5 L75.5,617 L70,617 Z"
          />
        </defs>
        <use transform="translate(-58 -610)" href="#description_icon-a" />
      </g>
    )
  },
  [IconNames.DotsVertical]: {
    element: (
      <g key="dots-vertical">
        <path d="M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z" />
      </g>
    )
  },
  [IconNames.Done]: {
    element: (
      <g key="done">
        <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
      </g>
    )
  },
  [IconNames.FilterList]: {
    element: (
      <g key="filter-list">
        <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z" />
      </g>
    )
  },
  [IconNames.FormatListNumeric]: {
    element: (
      <g key="format-list-numeric">
        <path d="M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z" />
      </g>
    )
  },
  [IconNames.Keyboard_arrow_down]: {
    element: (
      <g key="Keyboard_arrow_down">
        <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
        <path d="M0 0h24v24H0V0z" fill="none" />
      </g>
    )
  },
  [IconNames.Keyboard_arrow_up]: {
    element: (
      <g key="Keyboard_arrow_up">
        <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" />
        <path d="M0 0h24v24H0z" fill="none" />
      </g>
    )
  },
  [IconNames.ListBulleted]: {
    element: (
      <g key="list-bulleted-icon">
        <defs>
          <path
            id="list_icon-a"
            d="M59,243 L61,243 L61,241 L59,241 L59,243 Z M59,247 L61,247 L61,245 L59,245 L59,247 Z M59,239 L61,239 L61,237 L59,237 L59,239 Z M63,243 L77,243 L77,241 L63,241 L63,243 Z M63,247 L77,247 L77,245 L63,245 L63,247 Z M63,237 L63,239 L77,239 L77,237 L63,237 Z"
          />
        </defs>
        <use transform="translate(-59 -237)" href="#list_icon-a" />
      </g>
    )
  },
  [IconNames.ListBulleted]: {
    element: (
      <g key="list-bulleted-icon">
        <defs>
          <path
            id="list_icon-a"
            d="M59,243 L61,243 L61,241 L59,241 L59,243 Z M59,247 L61,247 L61,245 L59,245 L59,247 Z M59,239 L61,239 L61,237 L59,237 L59,239 Z M63,243 L77,243 L77,241 L63,241 L63,243 Z M63,247 L77,247 L77,245 L63,245 L63,247 Z M63,237 L63,239 L77,239 L77,237 L63,237 Z"
          />
        </defs>
        <use transform="translate(-59 -237)" href="#list_icon-a" />
      </g>
    )
  },
  [IconNames.ListBoxes]: {
    element: (
      <g key="list-boxes">
        <path d="M13 9.5h5v-2h-5v2zm0 7h5v-2h-5v2zm6 4.5H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2zM6 11h5V6H6v5zm1-4h3v3H7V7zM6 18h5v-5H6v5zm1-4h3v3H7v-3z" />
      </g>
    )
  },
  [IconNames.List]: {
    element: (
      <g key="list-icon">
        <path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z" />
      </g>
    )
  },
  [IconNames.LocalActivity]: {
    element: (
      <g key="local-activity-icon">
        <path d="M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z" />
        <use transform="translate(-59 -410)" href="#local_activity_icon-a" />
      </g>
    )
  },
  [IconNames.Location]: {
    element: (
      <g key="location-icon">
        <defs>
          <polygon
            id="location_icon-a"
            points="77 338 59 345.53 59 346.51 65.84 349.16 68.48 356 69.46 356"
          />
        </defs>
        <use transform="translate(-59 -338)" href="#location_icon-a" />
      </g>
    )
  },
  [IconNames.Lock]: {
    element: (
      <g key="lock">
        <path
          d="M558,520 C559.242641,520 560.25,518.992641 560.25,517.75 C560.25,516.50125 559.2375,515.5 558,515.5 C556.757359,515.5 555.75,516.507359 555.75,517.75 C555.75,518.992641 556.757359,520 558,520 Z M564.75,509.875 C565.992641,509.875 567,510.882359 567,512.125 L567,523.375 C567,524.617641 565.992641,525.625 564.75,525.625 L551.25,525.625 C550.007359,525.625 549,524.617641 549,523.375 L549,512.125 C549,510.87625 550.0125,509.875 551.25,509.875 L552.375,509.875 L552.375,507.625 C552.375,504.518398 554.893398,502 558,502 C559.491843,502 560.922584,502.592632 561.977476,503.647524 C563.032368,504.702416 563.625,506.133157 563.625,507.625 L563.625,509.875 L564.75,509.875 Z M558,504.25 C556.136039,504.25 554.625,505.761039 554.625,507.625 L554.625,509.875 L561.375,509.875 L561.375,507.625 C561.375,505.761039 559.863961,504.25 558,504.25 Z"
          transform="translate(-549 -502)"
        />
      </g>
    )
  },
  [IconNames.Navigation]: {
    element: (
      <g key="navigation">
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z" />
      </g>
    )
  },
  [IconNames.Pencil]: {
    element: (
      <g key="pencil">
        <path d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z" />
      </g>
    )
  },
  [IconNames.Pound]: {
    element: (
      <g key="pound">
        <path d="M5.41,21L6.12,17H2.12L2.47,15H6.47L7.53,9H3.53L3.88,7H7.88L8.59,3H10.59L9.88,7H15.88L16.59,3H18.59L17.88,7H21.88L21.53,9H17.53L16.47,15H20.47L20.12,17H16.12L15.41,21H13.41L14.12,17H8.12L7.41,21H5.41M9.53,9L8.47,15H14.47L15.53,9H9.53Z" />
      </g>
    )
  },
  [IconNames.PlusCircle]: {
    element: (
      <g key="plus-circle">
        <path d="M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M13,7H11V11H7V13H11V17H13V13H17V11H13V7Z" />
      </g>
    )
  },
  [IconNames.Security]: {
    element: (
      <g key="security">
        <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" />
      </g>
    )
  },
  [IconNames.SignIn]: {
    element: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="23"
        height="25"
        viewBox="0 0 23 25"
        fill="none"
      >
        <path
          d="M12.5 24V21.4444H20.6667V3.55556H12.5V1H20.6667C21.3083 1 21.8576 1.25023 22.3146 1.75069C22.7715 2.25116 23 2.85278 23 3.55556V21.4444C23 22.1472 22.7715 22.7488 22.3146 23.2493C21.8576 23.7498 21.3083 24 20.6667 24H12.5ZM10.1667 18.8889L8.5625 17.0361L11.5375 13.7778H2V11.2222H11.5375L8.5625 7.96389L10.1667 6.11111L16 12.5L10.1667 18.8889Z"
          fill="#396FA5"
        />
      </svg>
    )
  },
  [IconNames.SortVariant]: {
    element: (
      <g key="sort-variant">
        <path d="M3,13H15V11H3M3,6V8H21V6M3,18H9V16H3V18Z" />
      </g>
    )
  },
  [IconNames.StarComment]: {
    element: (
      <g key="starComment">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.85059 22.1496V3.55398C1.85059 3.10903 2.01946 2.71292 2.35721 2.36565C2.69498 2.01837 3.09385 1.84473 3.55384 1.84473H20.4462C20.8912 1.84473 21.2873 2.01837 21.6346 2.36565C21.9818 2.71292 22.1555 3.10903 22.1555 3.55398V16.4464C22.1555 16.8897 21.9818 17.2844 21.6346 17.6305C21.2873 17.9766 20.8912 18.1496 20.4462 18.1496H5.85059L1.85059 22.1496ZM3.55384 18.16L5.26744 16.4464H20.4462V3.55398H3.55384V18.16ZM9.07504 14.292L12 12.517L14.925 14.292L14.15 10.967L16.75 8.71703L13.325 8.44203L12 5.29203L10.675 8.44203L7.25004 8.71703L9.85004 10.967L9.07504 14.292Z"
            fill="#396FA5"
          />
        </svg>
      </g>
    )
  },
  [IconNames.Tag]: {
    element: (
      <g key="tag">
        <path d="M5.5,7A1.5,1.5 0 0,1 4,5.5A1.5,1.5 0 0,1 5.5,4A1.5,1.5 0 0,1 7,5.5A1.5,1.5 0 0,1 5.5,7M21.41,11.58L12.41,2.58C12.05,2.22 11.55,2 11,2H4C2.89,2 2,2.89 2,4V11C2,11.55 2.22,12.05 2.59,12.41L11.58,21.41C11.95,21.77 12.45,22 13,22C13.55,22 14.05,21.77 14.41,21.41L21.41,14.41C21.78,14.05 22,13.55 22,13C22,12.44 21.77,11.94 21.41,11.58Z" />
      </g>
    )
  },
  [IconNames.Translate]: {
    element: (
      <g key="translate">
        <path d="M21 4H11l-1-3H3c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h8l1 3h9c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7 16c-2.76 0-5-2.24-5-5s2.24-5 5-5c1.35 0 2.48.5 3.35 1.3L9.03 8.57c-.38-.36-1.04-.78-2.03-.78-1.74 0-3.15 1.44-3.15 3.21S5.26 14.21 7 14.21c2.01 0 2.84-1.44 2.92-2.41H7v-1.71h4.68c.07.31.12.61.12 1.02C11.8 13.97 9.89 16 7 16zm6.17-5.42h3.7c-.43 1.25-1.11 2.43-2.05 3.47-.31-.35-.6-.72-.86-1.1l-.79-2.37zm8.33 9.92c0 .55-.45 1-1 1H14l2-2.5-1.04-3.1 3.1 3.1.92-.92-3.3-3.25.02-.02c1.13-1.25 1.93-2.69 2.4-4.22H20v-1.3h-4.53V8h-1.29v1.29h-1.44L11.46 5.5h9.04c.55 0 1 .45 1 1v14z" />
      </g>
    )
  },
  [IconNames.Upload]: {
    element: (
      <g key="upload">
        <svg viewBox="0 0 35 47" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_1016_50358)">
            <path
              d="M24.9495 0.273438H2.53311C1.15941 0.273438 0.0429688 1.43538 0.0429688 2.87264V44.1737C0.0429688 45.6095 1.15941 46.7729 2.53311 46.7729H32.4213C33.7981 46.7729 34.9114 45.6096 34.9114 44.1737V10.6706L24.9495 0.273438ZM24.9495 3.94841L31.3908 10.6709H24.9495V3.94841ZM32.4219 44.1746H2.53372V2.87264H22.4589V10.6706C22.4589 12.1064 23.5729 13.2698 24.949 13.2698H32.4215V44.1739L32.4219 44.1746Z"
              fill="#808080"
            />
            <path
              d="M15.9026 37.719H19.3259V26.0263L24.0043 30.7964L26.4005 28.3532L17.5002 19.511L8.71387 28.4696L11.1101 30.9128L15.9026 26.0263V37.719Z"
              fill="#808080"
            />
          </g>
          <defs>
            <clipPath id="clip0_1016_50358">
              <rect width="34.875" height="46.5" fill="white" transform="translate(0.0625 0.25)" />
            </clipPath>
          </defs>
        </svg>
      </g>
    )
  },
  [IconNames.Web]: {
    element: (
      <g key="web">
        <path d="M16.36,14C16.44,13.34 16.5,12.68 16.5,12C16.5,11.32 16.44,10.66 16.36,10H19.74C19.9,10.64 20,11.31 20,12C20,12.69 19.9,13.36 19.74,14M14.59,19.56C15.19,18.45 15.65,17.25 15.97,16H18.92C17.96,17.65 16.43,18.93 14.59,19.56M14.34,14H9.66C9.56,13.34 9.5,12.68 9.5,12C9.5,11.32 9.56,10.65 9.66,10H14.34C14.43,10.65 14.5,11.32 14.5,12C14.5,12.68 14.43,13.34 14.34,14M12,19.96C11.17,18.76 10.5,17.43 10.09,16H13.91C13.5,17.43 12.83,18.76 12,19.96M8,8H5.08C6.03,6.34 7.57,5.06 9.4,4.44C8.8,5.55 8.35,6.75 8,8M5.08,16H8C8.35,17.25 8.8,18.45 9.4,19.56C7.57,18.93 6.03,17.65 5.08,16M4.26,14C4.1,13.36 4,12.69 4,12C4,11.31 4.1,10.64 4.26,10H7.64C7.56,10.66 7.5,11.32 7.5,12C7.5,12.68 7.56,13.34 7.64,14M12,4.03C12.83,5.23 13.5,6.57 13.91,8H10.09C10.5,6.57 11.17,5.23 12,4.03M18.92,8H15.97C15.65,6.75 15.19,5.55 14.59,4.44C16.43,5.07 17.96,6.34 18.92,8M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
      </g>
    )
  },
  [IconNames.Work]: {
    element: (
      <g key="work">
        <path d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z" />
      </g>
    )
  },
  [IconNames.Encrypted]: {
    element: (
      <g key="encrypted">
        <svg
          width="24"
          height="24"
          viewBox="0 0 16 21"
          fill="#ffff"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.5 13H9.5L8.925 9.775C9.25833 9.60833 9.52083 9.36667 9.7125 9.05C9.90417 8.73333 10 8.38333 10 8C10 7.45 9.80417 6.97917 9.4125 6.5875C9.02083 6.19583 8.55 6 8 6C7.45 6 6.97917 6.19583 6.5875 6.5875C6.19583 6.97917 6 7.45 6 8C6 8.38333 6.09583 8.73333 6.2875 9.05C6.47917 9.36667 6.74167 9.60833 7.075 9.775L6.5 13ZM8 20C5.68333 19.4167 3.77083 18.0875 2.2625 16.0125C0.754167 13.9375 0 11.6333 0 9.1V3L8 0L16 3V9.1C16 11.6333 15.2458 13.9375 13.7375 16.0125C12.2292 18.0875 10.3167 19.4167 8 20Z"
            fill="#396FA5"
          />
        </svg>
      </g>
    )
  }
}

export default Icons
